
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dAbO5", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");


var $g5gZt = parcelRequire("g5gZt");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");




const $8d1094a96cdc1d7a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    addItemText: {
        id: "company-hub.company-hub-common.config-panel.add-card-cta",
        defaultMessage: "Add card"
    }
});


const $85951a917e87bf4a$var$addButtonContentWrapperStyles = (0, $ecnYn.xcss)({
    height: '20px'
});
const $85951a917e87bf4a$export$6cb731ac7be1981a = ({ actionSubjectIdSuffix: actionSubjectIdSuffix, analyticsSource: analyticsSource, addItem: addItem, onAddItemKeyPress: onAddItemKeyPress, label: label })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onAddItemButtonClick = ()=>{
        addItem();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `add${actionSubjectIdSuffix}`,
                source: analyticsSource
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
        appearance: "primary",
        onClick: onAddItemButtonClick,
        onKeyPress: onAddItemKeyPress,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
            alignItems: "center",
            justifyContent: "center",
            gap: "space.050",
            xcss: $85951a917e87bf4a$var$addButtonContentWrapperStyles,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                    color: "currentColor",
                    label: ""
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...label || (0, $8d1094a96cdc1d7a$export$defe85febe8b728c).addItemText
                })
            ]
        })
    });
};
module.exports["AddItemButton"] = $85951a917e87bf4a$export$6cb731ac7be1981a;

});

parcelRegister("hECbK", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $1Whri = parcelRequire("1Whri");


var $cO1el = parcelRequire("cO1el");


var $gj7hi = parcelRequire("gj7hi");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $kZ5GD = parcelRequire("kZ5GD");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $4JDbp = parcelRequire("4JDbp");


var $4cOi8 = parcelRequire("4cOi8");

const $2ec1d6fee0534a73$var$CONTENT_WIDTH = 800;
const $2ec1d6fee0534a73$var$styles = {
    default: "_1bsb1c3h _4t3iv7uf",
    compact: "_4t3i16xz",
    containerStyles: "_1reo15vq _18m915vq _2rko1mok _1bsb1osq _kqswh2mm"
};
const $2ec1d6fee0534a73$export$73bba9cb9f06b02a = ({ layout: layout = (0, $4cOi8.CommonLayout).SPLIT_IMAGE_RIGHT, previewSizeVariant: previewSizeVariant = 'default', PreviewComponent: PreviewComponent })=>{
    const [containerWidth, setContainerWidth] = (0, $42omo.useState)(0);
    const calculatedScale = containerWidth ? containerWidth / $2ec1d6fee0534a73$var$CONTENT_WIDTH : 0;
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            $2ec1d6fee0534a73$var$styles.containerStyles
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.default), {
                setWidth: setContainerWidth
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                style: {
                    transform: `scale(${calculatedScale})`,
                    transformOrigin: 'top left'
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $2ec1d6fee0534a73$var$styles.default,
                        $2ec1d6fee0534a73$var$styles[previewSizeVariant]
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)(PreviewComponent, {
                        height: (0, $4cOi8.Height).MEDIUM,
                        layout: layout
                    })
                })
            })
        ]
    });
};


const $e1e57cfddd500cee$var$headingSizeMap = {
    default: 'xsmall',
    compact: 'xxsmall'
};
/**
 * Mapping layout variants to classnames
 */ const $e1e57cfddd500cee$var$variantMap = {
    default: 'defaultLayoutOption',
    compact: 'compactLayoutOption'
};
const $e1e57cfddd500cee$var$layoutOptionStyles = {
    defaultLayoutOption: "_2rko12b0 _1h6d1l7x _189ee4h9 _1dqonqa1 _bfhksm61 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _d0altlke",
    compactLayoutOption: "_ca0qutpp _n3tdutpp _19bv12x7 _u5f312x7",
    layoutOptionSelected: "_1h6dq98m",
    radioButtonWrapper: "_18u0r5cr _4cvr1h6o",
    layoutLabelHeadingWrapper: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _18u01i6y _19pkv77o"
};
const $e1e57cfddd500cee$export$f4ca495c8982b022 = ({ updateLayout: updateLayout, source: source, layoutOptions: layoutOptions, variant: variant = 'default', PreviewComponent: PreviewComponent, previewImage: previewImage, currentLayoutSelection: currentLayoutSelection })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleClickAnalytics = (0, $42omo.useCallback)((value)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'selected',
                actionSubject: 'layout',
                actionSubjectId: 'configPanelLayoutOptions',
                source: source,
                attributes: {
                    value: value
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const handleOnChange = (event)=>{
        const selectedOption = layoutOptions.find((option)=>option.value === event.currentTarget.value);
        if (selectedOption) {
            handleClickAnalytics(selectedOption.value);
            updateLayout(selectedOption.value);
        }
    };
    const handleOptionClick = (newLayoutValue)=>{
        const selectedValue = layoutOptions.find(({ value: value })=>value === newLayoutValue)?.value;
        handleClickAnalytics(selectedValue);
        updateLayout(newLayoutValue);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: layoutOptions.map(({ value: layout, label: i18nLabel, description: i18nDescription })=>{
            const label = formatMessage(i18nLabel);
            const description = i18nDescription && formatMessage(i18nDescription);
            const { imageSrc: imageSrc, imageSrcDark: imageSrcDark } = previewImage?.(layout) || {};
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                xcss: (0, $1Whri.cx)($e1e57cfddd500cee$var$layoutOptionStyles.defaultLayoutOption, currentLayoutSelection === layout && $e1e57cfddd500cee$var$layoutOptionStyles.layoutOptionSelected, $e1e57cfddd500cee$var$layoutOptionStyles[$e1e57cfddd500cee$var$variantMap[variant]]),
                onClick: ()=>handleOptionClick(layout),
                testId: "layout-option",
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    direction: "column",
                    gap: "space.100",
                    children: [
                        PreviewComponent && /*#__PURE__*/ (0, $l998X.jsx)((0, $2ec1d6fee0534a73$export$73bba9cb9f06b02a), {
                            layout: layout,
                            previewSizeVariant: variant,
                            PreviewComponent: PreviewComponent
                        }),
                        !PreviewComponent && previewImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                            src: imageSrc,
                            srcDark: imageSrcDark,
                            alt: "",
                            testId: `${layout}--image`
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            direction: "column",
                            gap: "space.050",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: (0, $1Whri.cx)($e1e57cfddd500cee$var$layoutOptionStyles.radioButtonWrapper),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kZ5GD.default), {
                                        value: layout,
                                        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                                            alignItems: "center",
                                            xcss: (0, $1Whri.cx)($e1e57cfddd500cee$var$layoutOptionStyles.layoutLabelHeadingWrapper),
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                                size: $e1e57cfddd500cee$var$headingSizeMap[variant],
                                                children: label
                                            })
                                        }),
                                        name: label,
                                        isChecked: layout === currentLayoutSelection,
                                        onChange: handleOnChange
                                    })
                                }),
                                description && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    align: "start",
                                    color: "color.text.subtlest",
                                    size: "small",
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            }, `${layout}${label}`);
        })
    });
};
module.exports["LayoutOptions"] = $e1e57cfddd500cee$export$f4ca495c8982b022;

});

parcelRegister("2oKNO", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $1s5hv = parcelRequire("1s5hv");


var $g3LxX = parcelRequire("g3LxX");


var $fOKpq = parcelRequire("fOKpq");


var $1VNax = parcelRequire("1VNax");








var $inPa6 = parcelRequire("inPa6");


var $51lK8 = parcelRequire("51lK8");


var $2WHHL = parcelRequire("2WHHL");


var $iTTcV = parcelRequire("iTTcV");


var $bSjaC = parcelRequire("bSjaC");


var $4T4vf = parcelRequire("4T4vf");


var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $be2Qa = parcelRequire("be2Qa");

const $af284bdcd0c65e3f$var$wrapperStyles = (0, $ecnYn.xcss)({
    gap: 'space.200'
});
const $af284bdcd0c65e3f$var$isEqual = (base)=>(value)=>base === value;
const $af284bdcd0c65e3f$var$isScroll = $af284bdcd0c65e3f$var$isEqual('scroll');
const $af284bdcd0c65e3f$var$isAuto = $af284bdcd0c65e3f$var$isEqual('auto');
const $af284bdcd0c65e3f$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $af284bdcd0c65e3f$var$isElementScrollable = (element)=>{
    const style = window.getComputedStyle(element);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $af284bdcd0c65e3f$var$isEither(overflow, $af284bdcd0c65e3f$var$isScroll) || $af284bdcd0c65e3f$var$isEither(overflow, $af284bdcd0c65e3f$var$isAuto);
};
const $af284bdcd0c65e3f$var$getClosestScrollableElement = (element)=>{
    if (!element) return null;
    if (element === document.body || element === document.documentElement) return null;
    if (!$af284bdcd0c65e3f$var$isElementScrollable(element)) return $af284bdcd0c65e3f$var$getClosestScrollableElement(element.parentElement);
    return element;
};
const $af284bdcd0c65e3f$export$ca49a56e05207e2d = ({ analyticsSource: analyticsSource, children: children, defaultItems: defaultItems, setDraggedItem: setDraggedItem, updateItems: updateItems, shouldUseCardV2UI: shouldUseCardV2UI = false })=>{
    const items = (0, $42omo.useRef)(defaultItems);
    const draggableZoneRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        let cleanupAutoScroll = null;
        return (0, $bSjaC.combine)((0, $4T4vf.monitorForElements)({
            canMonitor: ({ source: source })=>{
                return (0, $be2Qa.isItemData)(source.data);
            },
            onDragStart: ()=>{
                if (cleanupAutoScroll) return;
                const closestScrollable = $af284bdcd0c65e3f$var$getClosestScrollableElement(draggableZoneRef.current);
                if (!closestScrollable) return;
                cleanupAutoScroll = (0, $51lK8.autoScrollForElements)({
                    element: closestScrollable
                });
            },
            onDrop: ({ location: location, source: source })=>{
                const target = location.current.dropTargets[0];
                if (!target) return;
                const sourceData = source.data;
                const targetData = target.data;
                if (!(0, $be2Qa.isItemData)(sourceData) || !(0, $be2Qa.isItemData)(targetData)) return;
                const indexOfSource = defaultItems.findIndex((item)=>item.cardId === sourceData.item.cardId);
                const indexOfTarget = defaultItems.findIndex((item)=>item.cardId === targetData.item.cardId);
                if (indexOfTarget < 0) return;
                const closestEdgeOfTarget = (0, $2WHHL.extractClosestEdge)(targetData);
                items.current = (0, $iTTcV.reorderWithEdge)({
                    list: defaultItems,
                    startIndex: indexOfSource,
                    indexOfTarget: indexOfTarget,
                    closestEdgeOfTarget: closestEdgeOfTarget,
                    axis: 'vertical'
                });
                setDraggedItem?.();
                updateItems(items.current);
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'reordered',
                        actionSubject: 'items',
                        actionSubjectId: 'draggableItemsZone',
                        source: analyticsSource
                    }
                }).fire();
            }
        }), ()=>cleanupAutoScroll?.());
    }, [
        analyticsSource,
        items,
        createAnalyticsEvent,
        defaultItems,
        updateItems,
        setDraggedItem
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
        ref: draggableZoneRef,
        ...!shouldUseCardV2UI && {
            xcss: $af284bdcd0c65e3f$var$wrapperStyles
        },
        testId: "draggable-item-zone",
        children: children
    });
};



var $dCemt = parcelRequire("dCemt");

const $5f316676683a88de$var$upAccelerator = 'mod+option+shift+[';
const $5f316676683a88de$var$downAccelerator = 'mod+option+shift+]';
const $5f316676683a88de$export$ae634aeaeccf14ea = ({ items: items, removeItem: removeItem, analyticsSource: analyticsSource, actionSubjectIdPostFix: actionSubjectIdPostFix, itemsListRef: itemsListRef, shouldUseCardV2UI: shouldUseCardV2UI, updateItems: updateItems, itemLabel: itemLabel, canDeleteItem: canDeleteItem = true, renderItemContent: renderItemContent })=>{
    const { shortcutListener: shortcutListener } = (0, $fOKpq.useProductDependencies)();
    const isDeleteDisabled = items?.length === 1;
    const [{ selectedToEditCardId: selectedToEditCardId }, { setIsInViewMode: setIsInViewMode, setSelectedToEditCardId: setSelectedToEditCardId, setIsInAutoFocusMode: setIsInAutoFocusMode }] = (0, $g3LxX.useExtensionsState)();
    const firstItemId = items?.[0]?.cardId || null;
    (0, $42omo.useEffect)(()=>{
        // the order is important here
        // view mode should goes first to allow the active item to be set
        setIsInViewMode(false);
        if (selectedToEditCardId !== 'dragged-item') setSelectedToEditCardId(firstItemId);
        return ()=>{
            // Only reset card-level state on unmount. Do NOT reset isInViewMode here
            // because this component does not own the view mode lifecycle — the editor does.
            // Resetting isInViewMode to true on unmount would leave the editor in an
            // inconsistent state where subsequent openConfigPanel calls silently fail
            // (setSelectedExtensionLocalId is guarded by isInViewMode).
            setSelectedToEditCardId(null);
            if (!(0, $dh538.fg)('fix_unresponsive_edit_in_card')) setIsInViewMode(true);
            setIsInAutoFocusMode(true);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        firstItemId,
        setIsInViewMode,
        setSelectedToEditCardId,
        setIsInAutoFocusMode
    ]);
    const setDraggedItem = ()=>setSelectedToEditCardId('dragged-item');
    const swapItems = (source, target)=>{
        const newItems = [
            ...items
        ];
        const temp = newItems[target];
        newItems[target] = newItems[source];
        newItems[source] = temp;
        updateItems(newItems);
    };
    const [focusedItem, setFocusedItem] = (0, $42omo.useState)(undefined);
    const onMoveUp = ()=>{
        if (focusedItem !== undefined) {
            setDraggedItem();
            swapItems(focusedItem, focusedItem - 1);
            setFocusedItem(focusedItem - 1);
        }
    };
    const onMoveDown = ()=>{
        if (focusedItem !== undefined) {
            setDraggedItem();
            swapItems(focusedItem, focusedItem + 1);
            setFocusedItem(focusedItem + 1);
        }
    };
    const isFirstItemFocused = focusedItem === 0;
    const isLastItemFocused = focusedItem === items?.length - 1;
    const ShortcutListener = shortcutListener || (0, $42omo.Fragment);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        direction: "column",
        testId: "items-list-builder",
        gap: shouldUseCardV2UI ? undefined : 'space.200',
        ref: itemsListRef,
        children: (0, $1VNax.checkItems)(items) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $af284bdcd0c65e3f$export$ca49a56e05207e2d), {
            analyticsSource: analyticsSource,
            defaultItems: items,
            setDraggedItem: setDraggedItem,
            updateItems: updateItems,
            shouldUseCardV2UI: shouldUseCardV2UI,
            children: [
                !isFirstItemFocused && shortcutListener && /*#__PURE__*/ (0, $l998X.jsx)(ShortcutListener, {
                    accelerator: $5f316676683a88de$var$upAccelerator,
                    listener: onMoveUp
                }),
                !isLastItemFocused && shortcutListener && /*#__PURE__*/ (0, $l998X.jsx)(ShortcutListener, {
                    accelerator: $5f316676683a88de$var$downAccelerator,
                    listener: onMoveDown
                }),
                items.map((itemParameters, order)=>{
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dCemt.Item), {
                        actionSubjectIdPostFix: actionSubjectIdPostFix,
                        analyticsSource: analyticsSource,
                        itemParameters: itemParameters,
                        isDeleteDisabled: isDeleteDisabled,
                        isExpanded: selectedToEditCardId === itemParameters.cardId,
                        isFirstItem: order === 0,
                        isLastItem: order === items.length - 1,
                        onFocus: ()=>setFocusedItem(order),
                        onBlur: ()=>setFocusedItem(undefined),
                        order: order + 1,
                        removeItem: removeItem,
                        renderItemContent: renderItemContent,
                        setDraggedItem: setDraggedItem,
                        setExpandedItem: setSelectedToEditCardId,
                        swapItems: swapItems,
                        shouldUseCardV2UI: shouldUseCardV2UI,
                        itemLabel: itemLabel,
                        canDeleteItem: canDeleteItem
                    }, itemParameters.cardId);
                })
            ]
        })
    });
};
module.exports["ItemsListBuilder"] = $5f316676683a88de$export$ae634aeaeccf14ea;

});

parcelRegister("dCemt", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $2AytZ = parcelRequire("2AytZ");


var $gKvd9 = parcelRequire("gKvd9");


var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $2W0qg = parcelRequire("2W0qg");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $3v7tz = parcelRequire("3v7tz");


var $g3LxX = parcelRequire("g3LxX");








var $jTxSS = parcelRequire("jTxSS");


var $dRnqM = parcelRequire("dRnqM");


var $2WHHL = parcelRequire("2WHHL");


var $2n8po = parcelRequire("2n8po");


var $bSjaC = parcelRequire("bSjaC");


var $4T4vf = parcelRequire("4T4vf");


var $882hS = parcelRequire("882hS");


var $afUmf = parcelRequire("afUmf");


var $6f0Oj = parcelRequire("6f0Oj");







/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 









var $4rwCt = parcelRequire("4rwCt");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $hgeg8 = parcelRequire("hgeg8");


var $22Iw9 = parcelRequire("22Iw9");


var $euUgw = parcelRequire("euUgw");








var $8aNCk = parcelRequire("8aNCk");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $dOMrE = parcelRequire("dOMrE");

function $428e284101874428$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Cannot use `@atlaskit/button` here because it cancels `mousedown` events
 * which prevents dragging.
 */ const $428e284101874428$var$buttonStyles = {
    name: "txaqq0",
    styles: "color:var(--ds-text, #292A2E);border-radius:var(--ds-radius-small, 4px);padding:var(--ds-space-0, 0px);width:max-content;border:none;cursor:grab;display:flex"
};
const $428e284101874428$var$buttonAppearanceStyles = {
    default: {
        name: "1m0qggu",
        styles: "background-color:var(--ds-background-neutral, #0515240F);&:hover{background-color:var(--ds-background-neutral-hovered, #0B120E24);}&:active{background-color:var(--ds-background-neutral-pressed, #080F214A);}"
    },
    subtle: {
        name: "u8pb1t",
        styles: "background-color:var(--ds-background-neutral-subtle, #00000000);&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #0B120E24);}"
    },
    selected: {
        name: "1km59x1",
        styles: "background-color:var(--ds-background-selected, #E9F2FE);color:var(--ds-text-selected, #1868DB)"
    }
};
const $428e284101874428$export$c099c65cfbd84d0a = /*#__PURE__*/ (0, $42omo.forwardRef)(function DragHandleButton({ children: children, isSelected: isSelected = false, testId: testId, appearance: appearanceProp = 'default', type: /**
   * Defaulting to `button` instead of `submit` (native default in some cases).
   *
   * A type of `submit` only makes sense in a form context, and isn't very
   * relevant to a drag handle.
   *
   * `@atlaskit/button` also defaults to a type of `button` as well, as it
   * is more semantically appropriate in a wider range of cases.
   */ type = 'button', ...buttonProps }, ref) {
    const appearance = isSelected ? 'selected' : appearanceProp;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dOMrE.default), null, /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
        ref: ref,
        css: [
            $428e284101874428$var$buttonStyles,
            $428e284101874428$var$buttonAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        type: type,
        ...buttonProps
    }, children));
});


const $99266c3e40a077c6$export$4c99a519d851f90c = /*#__PURE__*/ (0, $42omo.forwardRef)(function DragHandleButton({ label: label, ...buttonProps }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $428e284101874428$export$c099c65cfbd84d0a), {
        ref: ref,
        ...buttonProps,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8aNCk))), {
            spacing: "spacious",
            label: label,
            size: "small"
        })
    });
});










const $7b98210e734672cc$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    moveUp: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.move.up.label",
        defaultMessage: "Move up"
    },
    moveDown: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.move.down.label",
        defaultMessage: "Move down"
    },
    arrowUp: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.arrow.up",
        defaultMessage: "up"
    },
    arrowDown: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.arrow.down",
        defaultMessage: "down"
    },
    reorder: {
        id: "company-hub.company-hub-common.link-cards.cards-area-container-components.draggable-card-container.reorder",
        defaultMessage: "reorder"
    }
});


const $fec75a069994527c$var$moveRowUp = (0, $hgeg8.makeKeyMapWithCommon)('Move Up', 'Ctrl-Alt-Shift-[');
const $fec75a069994527c$var$moveRowDown = (0, $hgeg8.makeKeyMapWithCommon)('Move Down', 'Ctrl-Alt-Shift-]');
const $fec75a069994527c$var$upKeyMap = (0, $hgeg8.tooltip)($fec75a069994527c$var$moveRowUp);
const $fec75a069994527c$var$downKeyMap = (0, $hgeg8.tooltip)($fec75a069994527c$var$moveRowDown);
const $fec75a069994527c$var$dragHandleStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'utility.elevation.surface.current',
    marginInline: 'space.050'
});
const $fec75a069994527c$var$draggingStyles = (0, $ecnYn.xcss)({
    opacity: '0.5'
});
const $fec75a069994527c$var$shortcut = (0, $ecnYn.xcss)({
    background: "var(--ds-background-neutral, #0515240F)",
    color: 'color.text.subtle',
    borderRadius: 'radius.small',
    padding: 'space.050',
    alignSelf: 'flex-end'
});
const $fec75a069994527c$var$getStyles = (isDragHandleHovered, isDragHandleFocused)=>({
        justifyContent: 'center',
        width: '16px',
        backgroundColor: "var(--ds-elevation-surface-current, #FFFFFF)",
        ...isDragHandleHovered && {
            backgroundColor: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
        },
        ...isDragHandleFocused && {
            backgroundColor: "var(--ds-elevation-surface-current, #FFFFFF)"
        }
    });
const $fec75a069994527c$export$d87bd93dda5de125 = ({ isDragHandleFocused: isDragHandleFocused, isDragging: isDragging, isFirst: isFirst, isLast: isLast, onMoveUp: onMoveUp, onMoveDown: onMoveDown, setIsDragHandleFocused: setIsDragHandleFocused, onFocus: onFocus, onBlur: onBlur })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const dragHandleRef = (0, $42omo.useRef)(null);
    const [isDragHandleHovered, setIsDragHandleHovered] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $fec75a069994527c$var$dragHandleStyles,
                    isDragging && $fec75a069994527c$var$draggingStyles
                ],
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $99266c3e40a077c6$export$4c99a519d851f90c), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    style: $fec75a069994527c$var$getStyles(isDragHandleHovered, isDragHandleFocused),
                    ref: (0, $4rwCt.mergeRefs)([
                        dragHandleRef,
                        triggerRef
                    ]),
                    ...triggerProps,
                    testId: "drag-handle",
                    label: formatMessage((0, $7b98210e734672cc$export$defe85febe8b728c).reorder),
                    onMouseLeave: ()=>{
                        if (!triggerProps.isSelected) setIsDragHandleHovered(false);
                    },
                    onMouseEnter: ()=>{
                        if (!triggerProps.isSelected) setIsDragHandleHovered(true);
                    },
                    onFocus: onFocus,
                    onBlur: onBlur
                })
            }),
        onOpenChange: (args)=>{
            const { isOpen: isOpen } = args;
            setIsDragHandleFocused(isOpen);
            if (!isOpen) setIsDragHandleHovered(false);
        },
        isOpen: isDragHandleFocused,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $ahaN7.default), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                    elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
                        label: formatMessage((0, $7b98210e734672cc$export$defe85febe8b728c).arrowUp)
                    }),
                    elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $fec75a069994527c$var$shortcut,
                        children: $fec75a069994527c$var$upKeyMap
                    }),
                    isDisabled: isFirst,
                    onClick: onMoveUp,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $7b98210e734672cc$export$defe85febe8b728c).moveUp
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                    elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($22Iw9))), {
                        label: formatMessage((0, $7b98210e734672cc$export$defe85febe8b728c).arrowDown)
                    }),
                    elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $fec75a069994527c$var$shortcut,
                        children: $fec75a069994527c$var$downKeyMap
                    }),
                    isDisabled: isLast,
                    onClick: onMoveDown,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $7b98210e734672cc$export$defe85febe8b728c).moveDown
                    })
                })
            ]
        })
    });
};



var $be2Qa = parcelRequire("be2Qa");

const $55b77b963efcc3f6$var$idle = {
    type: 'idle'
};
const $55b77b963efcc3f6$var$dragging = {
    type: 'is-dragging'
};
const $55b77b963efcc3f6$var$itemContainer = (0, $ecnYn.xcss)({
    alignItems: 'flex-start',
    position: 'relative'
});
const $55b77b963efcc3f6$var$itemContainerV2 = (0, $ecnYn.xcss)({
    alignItems: 'flex-start',
    position: 'relative',
    paddingTop: 'space.200',
    paddingBottom: 'space.200'
});
const $55b77b963efcc3f6$var$itemDisabled = (0, $ecnYn.xcss)({
    opacity: 0.4
});
const $55b77b963efcc3f6$var$itemPreview = (0, $ecnYn.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay',
    maxWidth: '360px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $55b77b963efcc3f6$var$draggableContent = (0, $ecnYn.xcss)({
    width: '100%'
});
const $55b77b963efcc3f6$export$f115a0a419405ac5 = ({ item: item, children: children, headerTitle: headerTitle, index: index, isDragHandleFocused: isDragHandleFocused, isFirstItem: isFirstItem, isLastItem: isLastItem, setDraggedItem: setDraggedItem, setIsDragHandleFocused: setIsDragHandleFocused, swapItems: swapItems, shouldUseCardV2UI: shouldUseCardV2UI, onBlur: onBlur, onFocus: onFocus })=>{
    const ref = (0, $42omo.useRef)(null);
    const [draggableState, setDraggableState] = (0, $42omo.useState)($55b77b963efcc3f6$var$idle);
    (0, $42omo.useEffect)(()=>{
        const element = ref.current;
        (0, $dRnqM.default)(element);
        const data = (0, $be2Qa.getItemData)({
            item: item,
            index: index
        });
        return (0, $bSjaC.combine)((0, $4T4vf.draggable)({
            element: element,
            getInitialData: ()=>data,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $afUmf.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $882hS.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render: ({ container: container })=>{
                        setDraggableState({
                            type: 'preview',
                            container: container
                        });
                    }
                });
            },
            onDragStart: ()=>{
                setDraggableState($55b77b963efcc3f6$var$dragging);
                setIsDragHandleFocused(false);
            },
            onDrop: ()=>{
                setDraggableState($55b77b963efcc3f6$var$idle);
                setDraggedItem();
            }
        }), (0, $4T4vf.dropTargetForElements)({
            element: element,
            canDrop: ({ source: source })=>{
                if (source.element === element) return false;
                return (0, $be2Qa.isItemData)(source.data);
            },
            getData: ({ input: input })=>{
                return (0, $2WHHL.attachClosestEdge)(data, {
                    element: element,
                    input: input,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            getIsSticky: ()=>{
                return true;
            },
            onDragEnter: ({ self: self })=>{
                const closestEdge = (0, $2WHHL.extractClosestEdge)(self.data);
                setDraggableState({
                    type: 'is-dragging-over',
                    closestEdge: closestEdge
                });
                setIsDragHandleFocused(false);
            },
            onDrag: ({ self: self })=>{
                const closestEdge = (0, $2WHHL.extractClosestEdge)(self.data);
                setDraggableState((current)=>{
                    if (current.type === 'is-dragging-over' && current.closestEdge === closestEdge) return current;
                    return {
                        type: 'is-dragging-over',
                        closestEdge: closestEdge
                    };
                });
            },
            onDragLeave: ()=>{
                setDraggableState($55b77b963efcc3f6$var$idle);
            },
            onDrop: ()=>{
                setDraggableState($55b77b963efcc3f6$var$idle);
                setDraggedItem();
            }
        }));
    }, [
        item,
        index,
        setDraggedItem,
        setIsDragHandleFocused
    ]);
    const isDragging = draggableState.type === 'is-dragging';
    const handleMove = (sourceIndex, targetIndex)=>{
        setDraggedItem();
        setIsDragHandleFocused(false);
        swapItems(sourceIndex, targetIndex);
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                grow: "fill",
                alignBlock: "stretch",
                xcss: [
                    shouldUseCardV2UI ? $55b77b963efcc3f6$var$itemContainerV2 : $55b77b963efcc3f6$var$itemContainer
                ],
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                    ref: ref,
                    alignInline: "start",
                    alignBlock: "center",
                    grow: "fill",
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        alignInline: "stretch",
                        xcss: $55b77b963efcc3f6$var$draggableContent,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $fec75a069994527c$export$d87bd93dda5de125), {
                                isDragging: isDragging,
                                isDragHandleFocused: isDragHandleFocused,
                                isFirst: isFirstItem,
                                isLast: isLastItem,
                                onMoveDown: ()=>{
                                    handleMove(index, index + 1);
                                },
                                onMoveUp: ()=>{
                                    handleMove(index, index - 1);
                                },
                                setIsDragHandleFocused: setIsDragHandleFocused,
                                onBlur: onBlur,
                                onFocus: onFocus
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: [
                                    isDragging && $55b77b963efcc3f6$var$itemDisabled,
                                    $55b77b963efcc3f6$var$draggableContent
                                ],
                                children: children
                            }),
                            draggableState.type === 'is-dragging-over' && draggableState.closestEdge ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
                                edge: draggableState.closestEdge,
                                ...!shouldUseCardV2UI && {
                                    gap: "var(--ds-space-200, 16px)"
                                }
                            }) : null
                        ]
                    })
                })
            }),
            draggableState.type === 'preview' && /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $55b77b963efcc3f6$var$itemPreview,
                children: headerTitle
            }), draggableState.container)
        ]
    });
};





const $0f333c30497d4bf4$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    collapseCardLabel: {
        id: "company-hub.company-hub-common.link-cards.card.collapse.label",
        defaultMessage: "Collapse card"
    },
    expandCardLabel: {
        id: "company-hub.company-hub-common.link-cards.card.expand.label",
        defaultMessage: "Expand card"
    },
    removeCardLabel: {
        id: "company-hub.company-hub-common.link-cards.card.remove.card.label",
        defaultMessage: "Remove card"
    },
    cardTitle: {
        id: "company-hub.company-hub-common.link-cards.card.title",
        defaultMessage: "Card {order}"
    },
    // Items can be referred to as "cards" (link cards extension) or "frames" (carousel v2)
    collapseItemLabel: {
        id: "company-hub.company-hub-common.shared-components.item.collapse.label",
        defaultMessage: "{itemLabel, select, card {Collapse card} frame {Collapse frame} other {Collapse card}}"
    },
    expandItemLabel: {
        id: "company-hub.company-hub-common.shared-components.item.expand.label",
        defaultMessage: "{itemLabel, select, card {Expand card} frame {Expand frame} other {Expand card}}"
    },
    removeItemLabel: {
        id: "company-hub.company-hub-common.shared-components.item.remove.label",
        defaultMessage: "{itemLabel, select, card {Remove card} frame {Remove frame} other {Remove card}}"
    },
    itemTitle: {
        id: "company-hub.company-hub-common.shared-components.item.title",
        defaultMessage: "{itemLabel, select, card {Card {order}} frame {Frame {order}} other {Card {order}}}"
    }
});


var $4dd3a2a96c820c98$export$2bc99c3a07d4b9fd = /*#__PURE__*/ function(ITEM_LABEL) {
    ITEM_LABEL["CARD"] = "card";
    ITEM_LABEL["FRAME"] = "frame";
    return ITEM_LABEL;
}({});
const $4dd3a2a96c820c98$var$iconColors = {
    hoverActive: "var(--ds-icon-danger, #C9372C)",
    default: "var(--ds-icon-subtle, #505258)",
    disabled: "var(--ds-text-disabled, #080F214A)"
};
const $4dd3a2a96c820c98$var$removeActiveStyles = (0, $ecnYn.xcss)({
    ':hover': {
        background: "var(--ds-background-danger, #FFECEB)",
        color: 'color.text.danger'
    },
    ':focus': {
        background: "var(--ds-background-danger, #FFECEB)",
        color: 'color.text.danger'
    }
});
const $4dd3a2a96c820c98$var$removeButtonStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    borderRadius: 'radius.small',
    display: 'flex',
    height: '32px',
    justifyContent: 'center'
});
const $4dd3a2a96c820c98$var$dragHandleFocusedWrapperStyles = (0, $ecnYn.xcss)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
});
const $4dd3a2a96c820c98$var$removeHoveredWrapperStyles = (0, $ecnYn.xcss)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-danger, #E2483D)"}`
});
const $4dd3a2a96c820c98$var$collapsibleStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    outline: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $4dd3a2a96c820c98$var$collapsibleStylesV2 = (0, $ecnYn.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $4dd3a2a96c820c98$var$collapsibleTriggerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.0',
    paddingRight: 'space.200',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    ':focus': {
        borderRadius: 'radius.small'
    },
    width: '100%'
});
const $4dd3a2a96c820c98$var$collapsibleTriggerStylesV2 = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    width: '100%'
});
const $4dd3a2a96c820c98$var$collapsibleContentStyles = (0, $ecnYn.xcss)({
    width: '100%',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    paddingTop: 'space.050',
    paddingBottom: 'space.150'
});
const $4dd3a2a96c820c98$var$collapsibleContentStylesV2 = (0, $ecnYn.xcss)({
    width: '100%',
    paddingLeft: 'space.050',
    paddingRight: 'space.0',
    paddingTop: 'space.050',
    paddingBottom: 'space.150'
});
const $4dd3a2a96c820c98$export$6d08773d2e66f8f2 = ({ actionSubjectIdPostFix: actionSubjectIdPostFix, analyticsSource: analyticsSource, itemParameters: itemParameters, canDeleteItem: canDeleteItem = true, isDeleteDisabled: isDeleteDisabled, isExpanded: isExpanded, isFirstItem: isFirstItem, isLastItem: isLastItem, onBlur: onBlur, onFocus: onFocus, order: order, removeItem: removeItem, setDraggedItem: setDraggedItem, setExpandedItem: setExpandedItem, swapItems: swapItems, shouldUseCardV2UI: shouldUseCardV2UI = false, itemLabel: itemLabel = "card", renderItemContent: renderItemContent })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const itemRef = (0, $42omo.useRef)(null);
    const [{ isInAutoFocusMode: isInAutoFocusMode, selectedToRemoveCardId: selectedToRemoveCardId }, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToRemoveCardId: setSelectedToRemoveCardId }] = (0, $g3LxX.useExtensionsState)();
    const CollapsedCardIcon = shouldUseCardV2UI ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
    const { cardId: cardId, title: title } = itemParameters;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isItemDisabled = (0, $3v7tz.useIsDisabledContext)();
    const onRemove = (0, $42omo.useCallback)(()=>{
        removeItem(cardId);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `delete${actionSubjectIdPostFix}`,
                source: analyticsSource
            }
        }).fire();
    }, [
        cardId,
        removeItem,
        createAnalyticsEvent,
        analyticsSource,
        actionSubjectIdPostFix
    ]);
    const isSelectedToRemove = selectedToRemoveCardId === cardId;
    let removeButtonColor;
    if (isDeleteDisabled || isItemDisabled) removeButtonColor = $4dd3a2a96c820c98$var$iconColors.disabled;
    else if (isSelectedToRemove) removeButtonColor = $4dd3a2a96c820c98$var$iconColors.hoverActive;
    else removeButtonColor = $4dd3a2a96c820c98$var$iconColors.default;
    const [isDragHandleFocused, setIsDragHandleFocused] = (0, $42omo.useState)(false);
    const isRemoveDisabled = isDeleteDisabled || isItemDisabled;
    const selectItemToRemove = (0, $42omo.useCallback)(()=>{
        !isRemoveDisabled && setSelectedToRemoveCardId(cardId);
    }, [
        isRemoveDisabled,
        cardId,
        setSelectedToRemoveCardId
    ]);
    const unselectItemToRemove = (0, $42omo.useCallback)(()=>{
        setSelectedToRemoveCardId(null);
    }, [
        setSelectedToRemoveCardId
    ]);
    const removeItemProps = {
        isDisabled: isRemoveDisabled,
        onClick: onRemove,
        onMouseOver: selectItemToRemove,
        onFocus: selectItemToRemove,
        onMouseOut: unselectItemToRemove,
        onBlur: unselectItemToRemove
    };
    const onCollapsibleTriggerClick = ()=>{
        setIsInAutoFocusMode(true);
        setExpandedItem(isExpanded ? '' : cardId);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: isExpanded ? 'collapsed' : 'expanded',
                actionSubject: 'card',
                actionSubjectId: 'cardCollapsible',
                source: analyticsSource
            }
        }).fire();
    };
    (0, $42omo.useEffect)(()=>{
        if (isExpanded && itemRef.current && isInAutoFocusMode) itemRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }, [
        isExpanded,
        itemRef,
        isInAutoFocusMode
    ]);
    let collapseLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).collapseCardLabel, expandLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).expandCardLabel, removeLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).removeCardLabel, headerTitle = formatMessage((0, $0f333c30497d4bf4$export$defe85febe8b728c).cardTitle, {
        order: order
    });
    if (itemLabel === "frame") {
        // @TODO, switch over to these messages unconditionally once
        // translations are available. The itemLabel context
        // is provided for correct string selection.
        collapseLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).collapseItemLabel;
        expandLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).expandItemLabel;
        removeLabel = (0, $0f333c30497d4bf4$export$defe85febe8b728c).removeItemLabel;
        headerTitle = formatMessage((0, $0f333c30497d4bf4$export$defe85febe8b728c).itemTitle, {
            itemLabel: itemLabel,
            order: order
        });
    }
    headerTitle = title || headerTitle;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        xcss: [
            shouldUseCardV2UI ? $4dd3a2a96c820c98$var$collapsibleStylesV2 : $4dd3a2a96c820c98$var$collapsibleStyles,
            isSelectedToRemove && !isRemoveDisabled && !shouldUseCardV2UI ? $4dd3a2a96c820c98$var$removeHoveredWrapperStyles : isDragHandleFocused && $4dd3a2a96c820c98$var$dragHandleFocusedWrapperStyles
        ],
        testId: "item-wrapper",
        ref: itemRef,
        grow: "fill",
        alignBlock: "center",
        alignInline: "start",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $55b77b963efcc3f6$export$f115a0a419405ac5), {
                index: order - 1,
                item: itemParameters,
                headerTitle: headerTitle,
                isDragHandleFocused: isDragHandleFocused,
                isFirstItem: isFirstItem,
                isLastItem: isLastItem,
                setDraggedItem: setDraggedItem,
                setIsDragHandleFocused: setIsDragHandleFocused,
                swapItems: swapItems,
                shouldUseCardV2UI: shouldUseCardV2UI,
                onFocus: onFocus,
                onBlur: onBlur,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
                    onClick: onCollapsibleTriggerClick,
                    onBlur: onBlur,
                    onFocus: onFocus,
                    backgroundColor: "color.background.neutral.subtle",
                    xcss: [
                        shouldUseCardV2UI ? $4dd3a2a96c820c98$var$collapsibleTriggerStylesV2 : $4dd3a2a96c820c98$var$collapsibleTriggerStyles
                    ],
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        spread: "space-between",
                        space: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                color: "color.text",
                                size: shouldUseCardV2UI ? 'medium' : undefined,
                                weight: shouldUseCardV2UI ? 'semibold' : undefined,
                                maxLines: 1,
                                children: headerTitle
                            }),
                            isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                                color: "var(--ds-text-subtle, #505258)",
                                label: formatMessage(collapseLabel),
                                size: "small"
                            }) : /*#__PURE__*/ (0, $l998X.jsx)(CollapsedCardIcon, {
                                color: "var(--ds-text-subtle, #505258)",
                                label: formatMessage(expandLabel),
                                size: "small"
                            })
                        ]
                    })
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                direction: "column",
                xcss: [
                    shouldUseCardV2UI ? $4dd3a2a96c820c98$var$collapsibleContentStylesV2 : $4dd3a2a96c820c98$var$collapsibleContentStyles
                ],
                testId: "item-content",
                children: [
                    renderItemContent(itemParameters, isItemDisabled),
                    canDeleteItem && /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
                        ...removeItemProps,
                        xcss: [
                            $4dd3a2a96c820c98$var$removeButtonStyles,
                            !isRemoveDisabled && $4dd3a2a96c820c98$var$removeActiveStyles
                        ],
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                            columnGap: "space.050",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                                    color: removeButtonColor,
                                    label: formatMessage(removeLabel, {
                                        itemLabel: itemLabel
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...removeLabel,
                                    values: {
                                        itemLabel: itemLabel
                                    }
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
module.exports["ITEM_LABEL"] = $4dd3a2a96c820c98$export$2bc99c3a07d4b9fd;
module.exports["Item"] = $4dd3a2a96c820c98$export$6d08773d2e66f8f2;

});

parcelRegister("izxBd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fOKpq = parcelRequire("fOKpq");


var $2Maq7 = parcelRequire("2Maq7");


var $eNm9g = parcelRequire("eNm9g");

const $b55fc346907dc922$export$549037637b109d47 = (items)=>{
    const [initialUnsplashResults, setInitialUnsplashResults] = (0, $42omo.useState)([]);
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const loadInitialUnsplashResults = (0, $42omo.useCallback)(()=>{
        if (initialUnsplashResults?.length === 0) (0, $eNm9g.getUnsplashPhotos)((0, $2Maq7.DEFAULT_UNSPLASH_QUERY_WORD), 1, submitError).then((result)=>{
            setInitialUnsplashResults(result);
        }).catch((_error)=>{
            setInitialUnsplashResults(undefined);
        });
    }, [
        initialUnsplashResults,
        setInitialUnsplashResults,
        submitError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (items?.length > 0) loadInitialUnsplashResults();
    }, [
        loadInitialUnsplashResults,
        items
    ]);
    return initialUnsplashResults;
};
module.exports["useInitialUnsplashResults"] = $b55fc346907dc922$export$549037637b109d47;

});

parcelRegister("7XNwX", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5spQU = parcelRequire("5spQU");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $1Whri = parcelRequire("1Whri");


var $dpPtd = parcelRequire("dpPtd");


var $a3fRD = parcelRequire("a3fRD");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $1oCLl = parcelRequire("1oCLl");


var $e1Ppq = parcelRequire("e1Ppq");


var $4cOi8 = parcelRequire("4cOi8");


var $lEBwV = parcelRequire("lEBwV");




const $554da5c3d4e48b76$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    imageLabel: {
        id: "company-hub.company-hub-common.link-cards.card.image.section.label",
        defaultMessage: "Image"
    },
    aiGenerationErrorFlagTitle: {
        id: "company-hub.company-hub-common.link-cards.card.image.ai-generation.error.flag.title",
        defaultMessage: "We couldn't generate your image"
    },
    aiGenerationErrorFlagDescription: {
        id: "company-hub.company-hub-common.link-cards.card.image.ai-generation.error.flag.description",
        defaultMessage: "Try again or choose a different image."
    },
    aiGenerationErrorFlagDescriptionWithReason: {
        id: "company-hub.company-hub-common.link-cards.card.image.ai-generation.error.flag.description-with-reason",
        defaultMessage: "{errorReason}. Try again or choose a different image."
    }
});


const $f24cb80f13977578$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION = 'cc_page_experiences_premium_macros_img_generation';
const $f24cb80f13977578$var$styles = {
    fieldWrapper: "_19pkpxbi"
};
const $f24cb80f13977578$export$d8d17c714ce39824 = ({ analyticsSource: analyticsSource, itemId: itemId, contentId: contentId, imageSrc: imageSrc, imageAltText: imageAltText, updateItemFormField: updateItemFormField, shouldAllowLinkFromUrl: shouldAllowLinkFromUrl = false })=>{
    // Gate the Premium Extensions image generation experiment behind the
    // `confluence-ai` feature so that AI-related UI is suppressed for IC
    // (Isolated Cloud) tenants where Confluence AI is not available.
    const isAiImgGenEnabled = (0, $1oCLl.expValEquals)($f24cb80f13977578$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION, 'isEnabled', true) && (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    const { generateImage: generateImage, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, error: aiHeaderImageError } = (0, $e1Ppq.useAIGeneratedCoverImage)({
        contentId: contentId
    });
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isAiHeaderImageLoading = (aiHeaderImageStatus === 'LOADING' || aiHeaderImageStatus === 'LOADING_WITH_ACCEPTANCE_FLOW') && !aiHeaderImageFileId; // Fire an analytics event when an AI-generated header image has been
    // produced successfully. We fire once per generation by tracking when
    // `aiHeaderImageFileId` transitions from falsy to truthy. Mirrors the
    // `headerImageAdded` analytics fired by Confluence's
    // EditorPageCoverPicture.handleAIGeneratedUpload, but adapted for the
    // company hub config panel.
    const prevAIHeaderImageFileIdRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!isAiImgGenEnabled) {
            prevAIHeaderImageFileIdRef.current = aiHeaderImageFileId;
            return;
        }
        const prevFileId = prevAIHeaderImageFileIdRef.current;
        const isNewFileId = !prevFileId && !!aiHeaderImageFileId;
        prevAIHeaderImageFileIdRef.current = aiHeaderImageFileId;
        if (!isNewFileId) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'added',
                actionSubject: 'image',
                actionSubjectId: 'companyHubImageAdded',
                source: analyticsSource,
                attributes: {
                    imageSource: 'aiGenerated',
                    imageId: aiHeaderImageFileId,
                    inputMethod: 'configPanel',
                    aiHeaderImageStatus: aiHeaderImageStatus,
                    isAIImgGenEnabled: isAiImgGenEnabled
                }
            }
        }).fire();
    }, [
        aiHeaderImageFileId,
        aiHeaderImageStatus,
        isAiImgGenEnabled,
        createAnalyticsEvent,
        analyticsSource
    ]);
    // Surface a flag to the user when AI image generation fails. We only fire
    // when the status transitions INTO `ERROR` (mirroring the Confluence header
    // image behaviour in EditorPageCoverPicture) so re-renders while already in
    // the error state don't produce duplicate flags.
    //
    // Each fire uses a unique flag `id` so that consecutive failures STACK in
    // the flag tray (matching the Confluence header image behaviour) rather
    // than replacing the previous flag — ADS `useFlags` dedupes by `id`.
    const prevAIHeaderImageStatusRef = (0, $42omo.useRef)(null);
    const aiGenerationErrorFlagCounterRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        if (!isAiImgGenEnabled) {
            prevAIHeaderImageStatusRef.current = aiHeaderImageStatus;
            return;
        }
        const prevStatus = prevAIHeaderImageStatusRef.current;
        const isTransitioningToError = prevStatus !== 'ERROR' && aiHeaderImageStatus === 'ERROR';
        prevAIHeaderImageStatusRef.current = aiHeaderImageStatus;
        if (!isTransitioningToError) return;
        const description = aiHeaderImageError ? formatMessage((0, $554da5c3d4e48b76$export$defe85febe8b728c).aiGenerationErrorFlagDescriptionWithReason, {
            errorReason: aiHeaderImageError
        }) : formatMessage((0, $554da5c3d4e48b76$export$defe85febe8b728c).aiGenerationErrorFlagDescription);
        aiGenerationErrorFlagCounterRef.current += 1;
        showFlag({
            id: `company-hub-image-field-ai-generation-error-flag-${aiGenerationErrorFlagCounterRef.current}`,
            title: formatMessage((0, $554da5c3d4e48b76$export$defe85febe8b728c).aiGenerationErrorFlagTitle),
            description: description,
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: "",
                size: "medium",
                color: "var(--ds-icon-danger, #C9372C)"
            })
        });
    }, [
        aiHeaderImageStatus,
        aiHeaderImageError,
        isAiImgGenEnabled,
        showFlag,
        formatMessage
    ]);
    const generateImageRef = (0, $42omo.useRef)(generateImage);
    generateImageRef.current = generateImage;
    const generateAndApplyImage = (0, $42omo.useCallback)(async (props)=>{
        const mediaFileId = await generateImageRef.current(props);
        if (mediaFileId) updateItemFormField(itemId, {
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: mediaFileId,
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: ''
        });
        return mediaFileId;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        itemId,
        updateItemFormField
    ]);
    const handleChangeImage = (0, $42omo.useCallback)((props)=>{
        const newImageSrc = 'fullSizeImageUrl' in props ? props.fullSizeImageUrl : props.uploadedImageId;
        const newAltText = props.altDescription;
        updateItemFormField(itemId, {
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: newImageSrc,
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: newAltText
        });
    }, [
        itemId,
        updateItemFormField
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: (0, $1Whri.cx)($f24cb80f13977578$var$styles.fieldWrapper),
        direction: "column",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            spread: "space-between",
            alignBlock: "center",
            testId: "image-field",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $554da5c3d4e48b76$export$defe85febe8b728c).imageLabel
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $lEBwV.MediaPickerSection), {
                    shouldAllowLinkFromUrl: shouldAllowLinkFromUrl,
                    contentId: contentId,
                    image: imageSrc ? {
                        imageSrc: imageSrc,
                        altText: imageAltText
                    } : undefined,
                    onChangeImage: handleChangeImage,
                    analyticsSource: analyticsSource,
                    shouldShowDeleteButton: true,
                    generateAIHeaderImage: isAiImgGenEnabled ? generateAndApplyImage : undefined,
                    isAiHeaderImageLoading: isAiImgGenEnabled ? isAiHeaderImageLoading : false
                })
            ]
        })
    });
};
module.exports["ImageField"] = $f24cb80f13977578$export$d8d17c714ce39824;

});

parcelRegister("lEBwV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5spQU = parcelRequire("5spQU");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $ghftu = parcelRequire("ghftu");


var $fZtQj = parcelRequire("fZtQj");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");














var $inPa6 = parcelRequire("inPa6");




var $1qfLF = parcelRequire("1qfLF");


var $bfgIy = parcelRequire("bfgIy");


var $gKvd9 = parcelRequire("gKvd9");


var $hw7wB = parcelRequire("hw7wB");


var $gj7hi = parcelRequire("gj7hi");


var $10CSJ = parcelRequire("10CSJ");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");





var $gmg8x = parcelRequire("gmg8x");

var $9e5cdbdc7fbe3d43$exports = {};
$9e5cdbdc7fbe3d43$exports = new URL("DefaultUploadImageBackground.144fddae.jpg", import.meta.url).toString();



var $jD7cj = parcelRequire("jD7cj");


var $jCIc5 = parcelRequire("jCIc5");


var $kHNfU = parcelRequire("kHNfU");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $jSnXV = parcelRequire("jSnXV");








var $7p4As = parcelRequire("7p4As");


var $gQhRa = parcelRequire("gQhRa");


var $69PnT = parcelRequire("69PnT");


var $1bY7o = parcelRequire("1bY7o");


var $3sFtD = parcelRequire("3sFtD");




var $1s5hv = parcelRequire("1s5hv");


var $4noo5 = parcelRequire("4noo5");


var $azUhE = parcelRequire("azUhE");


var $jqjsu = parcelRequire("jqjsu");




const $d5322b00bbb55dcf$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    buttonText: {
        id: "company-hub.common.media-components.unsplash.unsplash-browser.button.text",
        defaultMessage: "Browse unsplash"
    },
    errorText: {
        id: "company-hub.common.media-components.unsplash.unsplash-browser.error.text",
        defaultMessage: "We had trouble accessing this link. Try again."
    },
    inspirationText: {
        id: "company-hub.common.media-components.media-picker.ui.content.inspiration.text",
        defaultMessage: "Need inspiration?"
    },
    placeholderText: {
        id: "company-hub.common.media-components.media-picker.ui.content.placeholder.text",
        defaultMessage: "Add link from URL"
    }
});


const $89fc6885476c9938$var$styles = {
    elemBeforeInput: "_19bvu2gc",
    elemAfterInput: "_u5f3u2gc"
};
const $89fc6885476c9938$export$31a366db97ea3a6a = ({ currentUrl: currentUrl, analyticsSource: analyticsSource, handleImageSelection: handleImageSelection, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isFileId = Boolean(currentUrl?.match(/([0-9a-fA-F-]{36})/));
    const showCustomUploadedImage = !!currentUrl && isFileId;
    const [url, setUrl] = (0, $42omo.useState)(showCustomUploadedImage ? '' : currentUrl);
    const [isValidImage, setIsValidImage] = (0, $42omo.useState)(false); // TODO: submit to error monitoring service once we find CSM use for this
    const [error, setError] = (0, $42omo.useState)(false);
    const validateUrl = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(async (urlToValidate)=>{
        const trimmedUrl = urlToValidate.trim();
        if (!trimmedUrl) {
            setError(false);
            setIsValidImage(false);
            return;
        }
        if (!(0, $jqjsu.isValidUrl)(trimmedUrl)) {
            setError(true);
            setIsValidImage(false);
            return;
        }
        const normalizedUrl = (0, $jqjsu.normalizeUrl)(trimmedUrl);
        const isImage = await (0, $jqjsu.isImageURL)(normalizedUrl);
        if (!isImage) {
            setError(true);
            setIsValidImage(false);
            return;
        }
        handleImageSelection({
            fullSizeImageUrl: normalizedUrl,
            altDescription: ''
        });
        setError(false);
        setIsValidImage(true);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'entered',
                actionSubject: 'url',
                source: analyticsSource,
                attributes: {
                    imageSource: 'BrowseButtonAndLinkInput'
                }
            }
        }).fire();
    }, 300);
    const handleUrlInput = (e)=>{
        const newUrl = e.currentTarget.value;
        setUrl(newUrl);
        validateUrl(newUrl);
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                isDisabled: isDisabled,
                onChange: handleUrlInput,
                placeholder: formatMessage((0, $d5322b00bbb55dcf$export$defe85febe8b728c).placeholderText),
                elemBeforeInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $89fc6885476c9938$var$styles.elemBeforeInput,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                        color: "var(--ds-icon, #292A2E)",
                        label: ""
                    })
                }),
                elemAfterInput: isValidImage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $89fc6885476c9938$var$styles.elemAfterInput,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                        spacing: "spacious",
                        label: "valid",
                        color: "var(--ds-icon-success, #6A9A23)"
                    })
                }) : undefined,
                value: url
            }),
            error && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $d5322b00bbb55dcf$export$defe85febe8b728c).errorText
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $azUhE.MediaContentHelperMessage), {
                isDisabled: isDisabled,
                helperMessage: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $d5322b00bbb55dcf$export$defe85febe8b728c).inspirationText
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                appearance: "default",
                href: "https://unsplash.com",
                isDisabled: isDisabled,
                rel: "noopener noreferrer",
                shouldFitContainer: true,
                target: "_blank",
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    gap: "space.100",
                    alignItems: "center",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $d5322b00bbb55dcf$export$defe85febe8b728c).buttonText
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($69PnT))), {
                            label: "",
                            size: "small"
                        })
                    ]
                })
            })
        ]
    });
};



var $6YdGV = parcelRequire("6YdGV");


var $h3Ebw = parcelRequire("h3Ebw");


var $iqWjJ = parcelRequire("iqWjJ");

var $eVW6V = parcelRequire("eVW6V");


var $h92Kw = parcelRequire("h92Kw");










const $21feb76b65fdb5bb$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    fileUploadButtonText: {
        id: "company-hub.company-hub-common.unsplash.upload.text",
        defaultMessage: "Upload"
    },
    deleteImageButtonText: {
        id: "company-hub.company-hub-common.unsplash.delete.image.text",
        defaultMessage: "Remove image"
    },
    defaultBackgroundImageAltText: {
        id: "company-hub.company-hub-common.unsplash.background-img.default.label",
        defaultMessage: "Default background image for upload previewer"
    }
});


const $101400821b25fad6$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION = 'cc_page_experiences_premium_macros_img_generation';
const $101400821b25fad6$var$bottomSpacing = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
const $101400821b25fad6$var$removeBottomSpacing = (0, $ecnYn.xcss)({
    marginBottom: 'space.0'
});
const $101400821b25fad6$var$uploadFileContainer = (0, $ecnYn.xcss)({
    position: 'relative',
    borderRadius: 'radius.large',
    height: '124px',
    width: '100%',
    marginBottom: 'space.100',
    overflow: 'hidden'
});
const $101400821b25fad6$var$uploadFileButton = (0, $ecnYn.xcss)({
    position: 'absolute',
    left: '30%',
    right: '30%',
    bottom: '30%',
    top: '30%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $101400821b25fad6$export$d96ef1145be738e0 = ({ itemId: itemId, elementIdPrefix: elementIdPrefix, sectionLabel: sectionLabel, imageAltText: imageAltText, selectedImageUrl: selectedImageUrl, initialUnsplashResults: initialUnsplashResults, handleImageSelection: handleImageSelection, contentId: contentId, confluencePageId: confluencePageId, analyticsSource: analyticsSource, isPageTitleComponent: isPageTitleComponent = false, isNoImageAllowed: isNoImageAllowed = false, enableBottomSpacing: enableBottomSpacing = true, placement: placement, dropdownPopupComponentRef: dropdownPopupComponentRef, isDisabled: isDisabled = false, isAiHeaderImageLoading: isAiHeaderImageLoading, helperMessage: helperMessage, shouldShowDeleteButton: shouldShowDeleteButton = false, customMediaConfig: customMediaConfig, shouldAllowLinkFromUrl: shouldAllowLinkFromUrl = false, generateAIHeaderImage: generateAIHeaderImage })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { selectedDefaultImageUrl: selectedDefaultImageUrl, setDefaultUnsplashResults: setDefaultUnsplashResults, defaultUnsplashResults: defaultUnsplashResults, unSplashSearchResults: unSplashSearchResults, setUnsplashSearchResults: setUnsplashSearchResults, setError: setError, handleError: handleError, errorMessage: errorMessage } = (0, $eVW6V.useUnsplash)(isPageTitleComponent, selectedImageUrl, initialUnsplashResults);
    const [newUploadedImage, setNewUploadedImage] = (0, $42omo.useState)();
    const handleUploadedImage = (0, $42omo.useCallback)((props)=>{
        setNewUploadedImage(()=>props);
        handleImageSelection(props);
    }, [
        handleImageSelection
    ]);
    const handleAIGenerate = (0, $42omo.useCallback)(async (props)=>{
        if (!generateAIHeaderImage) return undefined;
        const mediaFileId = await generateAIHeaderImage(props);
        if (mediaFileId) // Mirror the manual upload path so the picker's local state
        // (newUploadedImage) reflects each new AI-generated image,
        // preventing stale renders on re-generation.
        handleUploadedImage({
            uploadedImageId: mediaFileId,
            altDescription: ''
        });
        return mediaFileId;
    }, [
        generateAIHeaderImage,
        handleUploadedImage
    ]);
    const handleDelete = ()=>{
        setNewUploadedImage(undefined);
        handleImageSelection({
            fullSizeImageUrl: '',
            altDescription: ''
        });
    };
    const { showCustomUploadedImage: showCustomUploadedImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: newUploadedImage ? newUploadedImage?.uploadedImageId : selectedDefaultImageUrl || undefined
    });
    const selectedDefaultUploadedImage = (0, $42omo.useRef)(undefined);
    (0, $42omo.useEffect)(()=>{
        if (!selectedDefaultUploadedImage.current && !newUploadedImage && showCustomUploadedImage) selectedDefaultUploadedImage.current = selectedDefaultImageUrl;
    }, [
        newUploadedImage,
        showCustomUploadedImage,
        selectedDefaultImageUrl
    ]);
    const customMediaAuthProvider = (0, $42omo.useMemo)(()=>{
        if (!customMediaConfig) return undefined;
        return ()=>Promise.resolve({
                token: customMediaConfig.mediaToken,
                baseUrl: customMediaConfig.mediaUrl,
                asapIssuer: customMediaConfig.asapIssuer
            });
    }, [
        customMediaConfig
    ]);
    const { mediaConfig: mediaConfig, handleUploadEnd: handleUploadEnd, handleUploadStart: handleUploadStart, handleOnError: handleOnError, isMediaBrowserOpen: isMediaBrowserOpen, openMediaBrowser: openMediaBrowser, closeMediaBrowser: closeMediaBrowser, isUploadingImage: isUploadingImage } = (0, $h92Kw.useUploadMediaConfig)({
        contentId: contentId,
        handleUploadedImageSelection: handleUploadedImage,
        analyticsSource: analyticsSource
    });
    const resolvedCollectionName = (0, $42omo.useMemo)(()=>{
        if (customMediaConfig) return customMediaConfig.mediaCollectionName;
        return mediaConfig?.collection;
    }, [
        customMediaConfig,
        mediaConfig
    ]);
    const resolvedAuthProvider = (0, $42omo.useMemo)(()=>{
        return customMediaConfig ? customMediaAuthProvider : mediaConfig?.authProvider;
    }, [
        customMediaConfig,
        customMediaAuthProvider,
        mediaConfig
    ]);
    const canOpenBrowser = Boolean(resolvedCollectionName && resolvedAuthProvider && openMediaBrowser);
    const handleUploadButtonClick = (0, $42omo.useCallback)(()=>{
        if (!canOpenBrowser) return;
        openMediaBrowser();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'customerImageUploadButton',
                source: analyticsSource
            }
        }).fire();
    }, [
        canOpenBrowser,
        openMediaBrowser,
        createAnalyticsEvent,
        analyticsSource
    ]);
    const unsplashSearchFieldId = itemId ? `${elementIdPrefix}-search-unsplash-${itemId}` : `${elementIdPrefix}-search-unsplash`;
    const initialUnsplashFive = (0, $42omo.useMemo)(()=>defaultUnsplashResults?.slice(0, 5), [
        defaultUnsplashResults
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                spread: "space-between",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                        htmlFor: unsplashSearchFieldId,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jCIc5.PanelSubheader), {
                            children: sectionLabel
                        })
                    }),
                    shouldShowDeleteButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        paddingBlockEnd: "space.200",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            isTooltipDisabled: false,
                            label: formatMessage((0, $21feb76b65fdb5bb$export$defe85febe8b728c).deleteImageButtonText),
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                            onClick: handleDelete,
                            isDisabled: isDisabled,
                            testId: "remove-image-button"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $azUhE.MediaContentHelperMessage), {
                isDisabled: isDisabled,
                helperMessage: helperMessage
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: $101400821b25fad6$var$uploadFileContainer,
                children: [
                    showCustomUploadedImage && !(0, $iqWjJ.isUnsplashImage)(selectedImageUrl) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        testId: "custom-image-upload",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kHNfU.CustomImageUploadRenderer), {
                            contentId: contentId,
                            imageAltText: imageAltText,
                            imageSrc: newUploadedImage?.uploadedImageId || selectedDefaultUploadedImage.current,
                            mediaConfigOverride: {
                                authProvider: customMediaAuthProvider,
                                collection: customMediaConfig?.mediaCollectionName
                            }
                        })
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        height: "124px",
                        width: "100%",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9e5cdbdc7fbe3d43$exports))),
                        alt: formatMessage((0, $21feb76b65fdb5bb$export$defe85febe8b728c).defaultBackgroundImageAltText)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $101400821b25fad6$var$uploadFileButton,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            onClick: handleUploadButtonClick,
                            isDisabled: isUploadingImage || isDisabled || !canOpenBrowser,
                            testId: "open-media-browser",
                            appearance: "primary",
                            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($hw7wB))),
                            children: formatMessage((0, $21feb76b65fdb5bb$export$defe85febe8b728c).fileUploadButtonText)
                        })
                    })
                ]
            }),
            resolvedCollectionName && resolvedAuthProvider && /*#__PURE__*/ (0, $l998X.jsx)((0, $10CSJ.BrowserLoader), {
                mediaClientConfig: {
                    authProvider: resolvedAuthProvider,
                    useSha256ForUploads: true
                },
                config: {
                    multiple: false,
                    fileExtensions: [
                        '.jpg',
                        '.jpeg',
                        '.png',
                        '.gif'
                    ],
                    uploadParams: {
                        collection: resolvedCollectionName,
                        onUploadRejection: mediaConfig?.onUploadRejection
                    }
                },
                isOpen: isMediaBrowserOpen,
                onClose: closeMediaBrowser,
                onUploadsStart: handleUploadStart,
                onError: handleOnError,
                onEnd: handleUploadEnd
            }),
            shouldAllowLinkFromUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $89fc6885476c9938$export$31a366db97ea3a6a), {
                analyticsSource: analyticsSource,
                currentUrl: selectedDefaultImageUrl,
                handleImageSelection: handleImageSelection,
                isDisabled: isDisabled
            }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $h3Ebw.UnsplashSearchBar), {
                        elementIdPrefix: elementIdPrefix,
                        unsplashSearchFieldId: unsplashSearchFieldId,
                        handleImageSelection: handleImageSelection,
                        analyticsSource: analyticsSource,
                        setDefaultUnsplashResults: setDefaultUnsplashResults,
                        defaultUnsplashResults: defaultUnsplashResults,
                        unSplashSearchResults: unSplashSearchResults,
                        setUnsplashSearchResults: setUnsplashSearchResults,
                        setError: setError,
                        handleError: handleError,
                        placement: placement,
                        dropdownPopupComponentRef: dropdownPopupComponentRef,
                        isUploadingImage: isUploadingImage || isDisabled
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                        xcss: enableBottomSpacing ? $101400821b25fad6$var$bottomSpacing : $101400821b25fad6$var$removeBottomSpacing,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $6YdGV.DefaultImagePicker), {
                                contentId: contentId,
                                confluencePageId: confluencePageId,
                                initialUnsplashResults: initialUnsplashFive,
                                handleImageSelection: handleImageSelection,
                                imageAltText: imageAltText,
                                previewUploadedImageId: newUploadedImage?.uploadedImageId,
                                initialUploadedImageId: selectedDefaultUploadedImage.current,
                                selectedImageUrl: selectedDefaultImageUrl,
                                analyticsSource: analyticsSource,
                                isUploadingImage: isUploadingImage || isDisabled,
                                isNoImageAllowed: isNoImageAllowed && !isPageTitleComponent,
                                mediaConfigOverride: {
                                    authProvider: customMediaAuthProvider,
                                    collection: customMediaConfig?.mediaCollectionName
                                }
                            }),
                            errorMessage && /*#__PURE__*/ (0, $l998X.jsx)((0, $jD7cj.FormFieldErrorMessage), {
                                children: errorMessage
                            })
                        ]
                    })
                ]
            }),
            (0, $1oCLl.expValEquals)($101400821b25fad6$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION, 'isEnabled', true) && (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai') && /*#__PURE__*/ (0, $l998X.jsx)((0, $gmg8x.RovoHeaderImageGenerator), {
                generateAIHeaderImage: generateAIHeaderImage ? handleAIGenerate : undefined,
                isAiHeaderImageLoading: isAiHeaderImageLoading,
                onSubmit: ({ selectedTheme: selectedTheme })=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'companyHubImageGenerationSubmitted',
                            source: analyticsSource,
                            attributes: {
                                selectedTheme: selectedTheme
                            }
                        }
                    }).fire();
                }
            })
        ]
    });
};





const $08f113053161f1c5$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    mediaPickerContentTitle: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.media-picker-content-title",
        defaultMessage: "Media"
    },
    mediaPickerButtonLabel: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.media-picker-button-label",
        defaultMessage: "Choose media"
    },
    mediaPickerContentHelperMessage: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.mdia-picker-helper-message",
        defaultMessage: "Choose high resolution images 1200px or wider for best results."
    }
});


const $0b87ab78f69513db$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION = 'cc_page_experiences_premium_macros_img_generation';
const $0b87ab78f69513db$var$styles = {
    mediaPickerPopupContainer: "_1bsbncxg _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
const $0b87ab78f69513db$export$b119da8ecc7e9645 = ({ onChangeImage: onChangeImage, image: image, contentId: contentId, analyticsSource: analyticsSource, shouldShowDeleteButton: shouldShowDeleteButton = false, onOpenUpdate: onOpenUpdate, isDisabled: isDisabled = false, isAiHeaderImageLoading: isAiHeaderImageLoading, customMediaConfig: customMediaConfig, shouldAllowLinkFromUrl: shouldAllowLinkFromUrl = false, generateAIHeaderImage: generateAIHeaderImage })=>{
    const [openPopup, setOpenPopup] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleSetOpenPopup = (open)=>{
        setOpenPopup(open);
        onOpenUpdate?.(open);
    }; // When the Premium Extensions image generation experiment is enabled, the
    // media picker popup should always render above the trigger button. This
    // prevents the panel from being clipped by, or obscuring, content rendered
    // below the trigger in the Company Hub configuration UI.
    // Also gated behind the `confluence-ai` feature so that AI-related UI is
    // suppressed for IC (Isolated Cloud) tenants where Confluence AI is not
    // available.
    const isPremiumImgGenerationEnabled = (0, $1oCLl.expValEquals)($0b87ab78f69513db$var$CC_PAGE_EXPERIENCES_PREMIUM_MACROS_IMG_GENERATION, 'isEnabled', true) && (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai');
    const popupPlacement = isPremiumImgGenerationEnabled ? 'top-end' : 'bottom-end';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        isOpen: openPopup,
        onClose: ()=>handleSetOpenPopup(false),
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $0b87ab78f69513db$var$styles.mediaPickerPopupContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $101400821b25fad6$export$d96ef1145be738e0), {
                    elementIdPrefix: `${analyticsSource}-media-picker`,
                    sectionLabel: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $08f113053161f1c5$export$defe85febe8b728c).mediaPickerContentTitle
                    }),
                    imageAltText: image?.altText,
                    selectedImageUrl: image?.imageSrc,
                    initialUnsplashResults: undefined,
                    handleImageSelection: onChangeImage,
                    contentId: contentId,
                    analyticsSource: analyticsSource,
                    helperMessage: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $08f113053161f1c5$export$defe85febe8b728c).mediaPickerContentHelperMessage
                    }),
                    shouldShowDeleteButton: shouldShowDeleteButton,
                    isDisabled: isDisabled,
                    customMediaConfig: customMediaConfig,
                    shouldAllowLinkFromUrl: shouldAllowLinkFromUrl,
                    generateAIHeaderImage: generateAIHeaderImage,
                    isAiHeaderImageLoading: isAiHeaderImageLoading
                })
            }),
        placement: popupPlacement,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                ...triggerProps,
                analyticsContext: {
                    source: `${analyticsSource}MediaPickerButton`
                },
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($fZtQj))),
                iconAfter: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        ...iconProps,
                        size: "small"
                    }),
                onClick: ()=>handleSetOpenPopup(!openPopup),
                "aria-label": formatMessage((0, $08f113053161f1c5$export$defe85febe8b728c).mediaPickerButtonLabel),
                isSelected: openPopup,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {})
            })
    });
};
module.exports["MediaPickerSection"] = $0b87ab78f69513db$export$b119da8ecc7e9645;

});

parcelRegister("7lwhH", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $10CSJ = parcelRequire("10CSJ");


var $1s5hv = parcelRequire("1s5hv");


var $4cOi8 = parcelRequire("4cOi8");


var $hY5v2 = parcelRequire("hY5v2");

var $h92Kw = parcelRequire("h92Kw");




const $5d69590c133cbf20$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    sectionLabel: {
        id: "company-hub.company-hub-common.link-cards.card.image.section.label",
        defaultMessage: "Image"
    }
});


const $8bc4a4109967f242$var$styles = {
    fieldWrapper: "_19pkpxbi"
};
const $8bc4a4109967f242$export$47c17c5f362608ab = ({ analyticsSource: analyticsSource, idPrefix: idPrefix, itemId: itemId, confluencePageId: confluencePageId, contentId: contentId, imageSrc: imageSrc, imageAltText: imageAltText, initialUnsplashResults: initialUnsplashResults, isNoImageAllowed: isNoImageAllowed, updateItemFormField: updateItemFormField })=>{
    const intl = (0, $aXWIB.useIntl)();
    const handleUnsplashImageSelection = (0, $42omo.useCallback)(({ fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription })=>{
        updateItemFormField(itemId, {
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: fullSizeImageUrl,
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: altDescription
        });
    }, [
        itemId,
        updateItemFormField
    ]);
    const handleUploadedImageSelection = (0, $42omo.useCallback)(({ uploadedImageId: uploadedImageId, altDescription: altDescription })=>{
        updateItemFormField(itemId, {
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_SRC]: uploadedImageId,
            [(0, $4cOi8.ITEM_FIELDS).IMAGE_ALT_TEXT]: altDescription
        });
    }, [
        itemId,
        updateItemFormField
    ]);
    const { mediaConfig: mediaConfig, handleUploadEnd: handleUploadEnd, handleUploadStart: handleUploadStart, handleOnError: handleOnError, isMediaBrowserOpen: isMediaBrowserOpen, openMediaBrowser: openMediaBrowser, closeMediaBrowser: closeMediaBrowser, isUploadingImage: isUploadingImage } = (0, $h92Kw.useUploadMediaConfig)({
        contentId: contentId,
        handleUploadedImageSelection: handleUploadedImageSelection,
        analyticsSource: analyticsSource
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            xcss: (0, $1Whri.cx)($8bc4a4109967f242$var$styles.fieldWrapper),
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $hY5v2.UnsplashSearch), {
                    id: itemId,
                    selectedImageUrl: imageSrc,
                    imageAltText: imageAltText,
                    sectionLabel: intl.formatMessage((0, $5d69590c133cbf20$export$defe85febe8b728c).sectionLabel),
                    initialUnsplashResults: initialUnsplashResults,
                    idPrefix: idPrefix,
                    handleImageSelection: handleUnsplashImageSelection,
                    analyticsSource: analyticsSource,
                    analyticsActionSubject: "button",
                    analyticsActionSubjectId: "customerImageUpload",
                    openMediaBrowser: openMediaBrowser,
                    contentId: contentId,
                    confluencePageId: confluencePageId,
                    isUploadingImage: isUploadingImage,
                    isNoImageAllowed: isNoImageAllowed
                }),
                mediaConfig?.collection ? /*#__PURE__*/ (0, $l998X.jsx)((0, $10CSJ.BrowserLoader), {
                    mediaClientConfig: {
                        authProvider: mediaConfig?.authProvider,
                        useSha256ForUploads: true
                    },
                    config: {
                        multiple: false,
                        fileExtensions: [
                            '.jpg',
                            '.jpeg',
                            '.png',
                            '.gif'
                        ],
                        uploadParams: {
                            collection: mediaConfig.collection,
                            onUploadRejection: mediaConfig?.onUploadRejection
                        }
                    },
                    isOpen: isMediaBrowserOpen,
                    onClose: closeMediaBrowser,
                    onUploadsStart: handleUploadStart,
                    onError: handleOnError,
                    onEnd: handleUploadEnd
                }) : null
            ]
        })
    });
};
module.exports["UnsplashSearchField"] = $8bc4a4109967f242$export$47c17c5f362608ab;

});

parcelRegister("8jjEv", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $hmuev = parcelRequire("hmuev");


var $1bY7o = parcelRequire("1bY7o");


var $7bZ3i = parcelRequire("7bZ3i");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");


var $hn4RR = parcelRequire("hn4RR");


var $9CM6e = parcelRequire("9CM6e");








var $4iPjq = parcelRequire("4iPjq");


var $5qrxS = parcelRequire("5qrxS");


var $fOKpq = parcelRequire("fOKpq");

const $a01e638968d35f1e$var$supportedPluginKeys = [
    'confluence',
    'jira',
    'atlas',
    'loom'
];
const $a01e638968d35f1e$export$8f5a036ec4993fc5 = ({ cloudId: cloudId, link: link, setIsOpen: setIsOpen, onLinkSelect: onLinkSelect })=>{
    const { linkPickerConfig: linkPickerConfig } = (0, $fOKpq.useProductDependencies)();
    const handleSubmit = (payload)=>{
        onLinkSelect(payload);
        setIsOpen(false);
    };
    const handleCancel = ()=>{
        setIsOpen(false);
    };
    const { isLoading: isLoading, plugins: plugins } = (0, $5qrxS.useLinkPickerPlugins)({
        cloudId: cloudId,
        product: 'confluence'
    });
    const filteredPlugins = (0, $42omo.useMemo)(()=>{
        return plugins.filter((plugin)=>{
            return plugin.tabKey && $a01e638968d35f1e$var$supportedPluginKeys.includes(plugin.tabKey);
        });
    }, [
        plugins
    ]);
    // Use custom plugins if provided, otherwise use default filtered plugins
    const pluginsToUse = linkPickerConfig?.linkPickerPlugins || filteredPlugins;
    const isLoadingPlugins = linkPickerConfig?.linkPickerPlugins ? false : isLoading;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4iPjq.default), {
        plugins: pluginsToUse,
        isLoadingPlugins: isLoadingPlugins,
        url: link.url,
        onSubmit: handleSubmit,
        onCancel: handleCancel,
        hideDisplayText: true
    });
};





const $647f79795a021064$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    clearIconLabel: {
        id: "company-hub.company-hub-common.link-picker.clear-icon-label",
        defaultMessage: "Clear link selection"
    },
    popupPlaceholderText: {
        id: "company-hub.company-hub-common.link-picker.popup-placeholder-text",
        defaultMessage: "Add any link"
    }
});


const $9a2b125c92105a3b$var$styles = {
    disabled: "_syaz1gmx",
    link: "_p12fmgvx",
    placeholder: "_zulp12x7 _16jlkb7n _1o9zidpf _i0dlf1ug _4cvr1h6o _syazazsu",
    selection: "_18zr1b66 _4cvr1h6o _1bah1yb4 _ca0qze3t _n3tdze3t",
    trigger: "_2rko12b0 _18zrpxbi _bfhksm61 _4t3i1ylp _ca0qze3t _n3tdze3t",
    triggerPressed: "_bfhkfcek",
    unresolvedLink: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
};
const $9a2b125c92105a3b$var$getDefaultPayload = (link, title)=>({
        url: link || '',
        displayText: null,
        title: title || null,
        meta: {
            inputMethod: 'manual'
        }
    });
const $9a2b125c92105a3b$var$Placeholder = ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $9a2b125c92105a3b$var$styles.placeholder,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                label: ""
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $647f79795a021064$export$defe85febe8b728c).popupPlaceholderText
            })
        ]
    });
const $9a2b125c92105a3b$export$901b688e8da62820 = ({ id: id, cloudId: cloudId, link: link, title: title, handleSelectLink: handleSelectLink, handleClearLink: handleClearLink, isDisabled: isDisabled })=>{
    const selectedLinkPayload = $9a2b125c92105a3b$var$getDefaultPayload(link, title);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [isLinkFallbackError, setIsLinkFallbackError] = (0, $42omo.useState)(false);
    const onLinkClick = ()=>window.open(selectedLinkPayload.url, '_blank');
    const onResolve = ()=>setIsLinkFallbackError(false);
    const onError = ({ status: status })=>setIsLinkFallbackError(status !== 'forbidden' && status !== 'unauthorized');
    const ResolvedLink = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $9a2b125c92105a3b$var$styles.link,
            children: !isLinkFallbackError && !isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
                appearance: "inline",
                onClick: onLinkClick,
                onError: onError,
                onResolve: onResolve,
                truncateInline: true,
                url: selectedLinkPayload.url
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $hn4RR.default), {
                ...!isDisabled && {
                    href: selectedLinkPayload.url
                },
                onClick: (e)=>e.stopPropagation(),
                target: "_blank",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($9a2b125c92105a3b$var$styles.unresolvedLink, isDisabled && $9a2b125c92105a3b$var$styles.disabled),
                    children: selectedLinkPayload.url
                })
            })
        });
    };
    const onLinkClear = (e)=>{
        e.stopPropagation();
        setIsLinkFallbackError(false);
        handleClearLink();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            id: id,
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "left",
            content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $a01e638968d35f1e$export$8f5a036ec4993fc5), {
                    cloudId: cloudId,
                    link: selectedLinkPayload,
                    onLinkSelect: handleSelectLink,
                    setIsOpen: setIsOpen
                }),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                    ...triggerProps,
                    isDisabled: isDisabled,
                    onClick: ()=>setIsOpen(!isOpen),
                    testId: "link-picker-popup-button",
                    style: {
                        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
                    },
                    xcss: (0, $1Whri.cx)($9a2b125c92105a3b$var$styles.trigger, isOpen && $9a2b125c92105a3b$var$styles.triggerPressed),
                    children: !!selectedLinkPayload.url ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                        xcss: $9a2b125c92105a3b$var$styles.selection,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)(ResolvedLink, {}),
                            !isDisabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                onClick: onLinkClear,
                                appearance: "subtle",
                                spacing: "compact",
                                label: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...(0, $647f79795a021064$export$defe85febe8b728c).clearIconLabel
                                }),
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev)))
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $l998X.jsx)($9a2b125c92105a3b$var$Placeholder, {})
                }),
            shouldRenderToParent: (0, $dh538.fg)('should-render-to-parent-should-be-true-conf')
        })
    });
};
module.exports["LinkPicker"] = $9a2b125c92105a3b$export$901b688e8da62820;

});

parcelRegister("d0hoS", function(module, exports) {

var $l998X = parcelRequire("l998X");

/**
 * @generated SignedSource<<ba1d1b91aa720fe04c4e7027b599a35e>>
 * @relayHash b02d8f8b31305d13be27cef9e8b950ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0edbf1f8d53711cef0a2bc558686119f8ba6622bfe9a75dc0d54f98aa2d1c1f8
const $8c19f56c2352a4c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-published",
                                        "cover-picture-id-draft"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-published\",\"cover-picture-id-draft\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchPageCoverImageQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchPageCoverImageQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "0edbf1f8d53711cef0a2bc558686119f8ba6622bfe9a75dc0d54f98aa2d1c1f8",
            "metadata": {},
            "name": "useFetchPageCoverImageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8c19f56c2352a4c4$var$node.hash = "0855dab8d0960c23520163cfbddf5236";
var $8c19f56c2352a4c4$export$2e2bcd8739ae039 = $8c19f56c2352a4c4$var$node;



var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $irOoi = parcelRequire("irOoi");


var $inPa6 = parcelRequire("inPa6");


var $dpPtd = parcelRequire("dpPtd");


var $a3fRD = parcelRequire("a3fRD");


var $kDHbX = parcelRequire("kDHbX");


var $gWF6I = parcelRequire("gWF6I");


var $7w8ah = parcelRequire("7w8ah");




const $1308770a57e72d89$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    fetchErrorTitle: {
        id: "company-hub.company-hub-common.link-cards.fetch-cover-image.fetch.error.title",
        defaultMessage: "We can\u2019t upload your image"
    },
    fetchErrorDescription: {
        id: "company-hub.company-hub-common.link-cards.fetch-cover-image.fetch.error.description",
        defaultMessage: "Refresh the page and try again"
    }
});


const $0e64e10de69315d4$var$extractId = (data)=>{
    const isLivePage = data?.content?.nodes?.[0]?.subType === 'live';
    let imageProperty;
    if (isLivePage) imageProperty = data?.content?.nodes?.[0]?.properties?.nodes?.find((image)=>image?.key === (0, $7w8ah.CoverPictureIdPropertyKey).DRAFT);
    else {
        imageProperty = data?.content?.nodes?.[0]?.properties?.nodes?.find((image)=>image?.key === (0, $7w8ah.CoverPictureIdPropertyKey).PUBLISHED);
        if (!imageProperty) imageProperty = data?.content?.nodes?.[0]?.properties?.nodes?.find((image)=>image?.key === (0, $7w8ah.CoverPictureIdPropertyKey).DRAFT);
    }
    return (0, $7w8ah.propertyToId)(imageProperty)?.value.id;
};
function $0e64e10de69315d4$export$d09c7708bbcc7c1a(analyticsSource) {
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const environment = (0, $gWF6I.useRelayEnvironmentProvider)().getEnvironment({});
    return (0, $42omo.useCallback)(async (confluencePageId, image)=>{
        if (!confluencePageId) return image?.url;
        let coverImageUrl;
        try {
            const data = await (0, $irOoi.fetchQuery)(environment, (0, $8c19f56c2352a4c4$export$2e2bcd8739ae039), {
                id: confluencePageId ?? ''
            }).toPromise();
            coverImageUrl = $0e64e10de69315d4$var$extractId(data);
            if (coverImageUrl) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'selected',
                    actionSubject: 'image',
                    source: analyticsSource,
                    attributes: {
                        imageSource: 'imageFoundOnPage'
                    }
                }
            }).fire();
        } catch (error) {
            showFlag({
                id: 'fetch-cover-image-error',
                title: formatMessage((0, $1308770a57e72d89$export$defe85febe8b728c).fetchErrorTitle),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                    label: "",
                    size: "medium",
                    color: "var(--ds-icon-danger, #C9372C)"
                }),
                description: formatMessage((0, $1308770a57e72d89$export$defe85febe8b728c).fetchErrorDescription)
            });
            (0, $kDHbX.fireErrorAnalytics)({
                error: error instanceof Error ? error : new Error('Failed to fetch page cover image'),
                meta: {
                    id: 'useFetchPageCoverImage',
                    packageName: '@atlassian/company-hub-common'
                }
            });
        }
        return coverImageUrl || image?.url;
    }, [
        analyticsSource,
        createAnalyticsEvent,
        showFlag,
        formatMessage,
        environment
    ]);
}
module.exports["useFetchCoverImage"] = $0e64e10de69315d4$export$d09c7708bbcc7c1a;

});

parcelRegister("k1IsV", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $82gXq = parcelRequire("82gXq");


var $3v7tz = parcelRequire("3v7tz");

const $8ba72fdae90322d2$var$toggleFieldContainerDisabledStyles = (0, $ecnYn.xcss)({
    color: 'color.text.disabled'
});
const $8ba72fdae90322d2$var$labelWrapperStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    flexGrow: 1,
    gap: 'space.100'
});
const $8ba72fdae90322d2$export$f91e8bfeb5571984 = ({ Icon: Icon, id: id, label: label, isDisabled: isDisabled, ...toggleProps })=>{
    const isDisabledContext = (0, $3v7tz.useIsDisabledContext)();
    const isToggleDisabled = isDisabled ?? isDisabledContext;
    if (!id) id = `toggle-${label.replace(/\s+/g, '-').toLowerCase()}-property`;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        alignItems: "center",
        xcss: isToggleDisabled && $8ba72fdae90322d2$var$toggleFieldContainerDisabledStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                xcss: $8ba72fdae90322d2$var$labelWrapperStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("label", {
                        htmlFor: id,
                        children: label
                    }),
                    Icon
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $82gXq.default), {
                ...toggleProps,
                isDisabled: isToggleDisabled,
                id: id
            })
        ]
    });
};
module.exports["ToggleField"] = $8ba72fdae90322d2$export$f91e8bfeb5571984;

});

parcelRegister("jQ0mm", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $cO1el = parcelRequire("cO1el");


var $ghftu = parcelRequire("ghftu");


var $gKvd9 = parcelRequire("gKvd9");


var $lGgRw = parcelRequire("lGgRw");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $kZ5GD = parcelRequire("kZ5GD");


var $4noo5 = parcelRequire("4noo5");


var $4cOi8 = parcelRequire("4cOi8");


var $8jjEv = parcelRequire("8jjEv");




const $252cf81a0f143938$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    buttonHeading: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.button-heading",
        defaultMessage: "Button"
    },
    textPlaceholder: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.button-text-placeholder",
        defaultMessage: "View"
    },
    deleteIconLabel: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.delete-icon-label",
        defaultMessage: "Delete"
    },
    defaultButtonStyleLabel: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.light-button-style-label",
        defaultMessage: "Default"
    },
    alternativeButtonStyleLabel: {
        id: "company-hub.company-hub-common.spotlight.spotlight-config-panel.dark-button-style-label",
        defaultMessage: "Alternative"
    }
});


const $4d261656ae8fd0a9$var$popupWrapper = (0, $ecnYn.xcss)({
    width: '262px'
});
const $4d261656ae8fd0a9$var$defaultRadioOptionStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.250',
    paddingBlock: 'space.050',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay',
    color: 'color.text'
});
const $4d261656ae8fd0a9$var$alternativeRadioOptionStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    color: 'color.text.inverse'
});
const $4d261656ae8fd0a9$export$322c06619d3c1a57 = (props)=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)($4d261656ae8fd0a9$var$PopupContent, {
                ...props
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    ...triggerProps,
                    isSelected: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            ...iconProps,
                            size: "small"
                        }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $252cf81a0f143938$export$defe85febe8b728c).buttonHeading
                    })
                })
            })
    });
};
const $4d261656ae8fd0a9$var$PopupContent = ({ text: text, link: link, style: style, source: source, buttonStyles: buttonStyles, handleSelectLink: handleSelectLink, handleClearLink: handleClearLink, handleClearButton: handleClearButton, updateButtonText: updateButtonText, updateButtonStyle: updateButtonStyle, cloudId: cloudId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    const buttonStyleOptions = buttonStyles || [
        {
            label: intl.formatMessage((0, $252cf81a0f143938$export$defe85febe8b728c).defaultButtonStyleLabel),
            value: (0, $4cOi8.ButtonStyle).DEFAULT,
            styles: $4d261656ae8fd0a9$var$defaultRadioOptionStyles
        },
        {
            label: intl.formatMessage((0, $252cf81a0f143938$export$defe85febe8b728c).alternativeButtonStyleLabel),
            value: (0, $4cOi8.ButtonStyle).ALTERNATIVE_1,
            styles: [
                $4d261656ae8fd0a9$var$defaultRadioOptionStyles,
                $4d261656ae8fd0a9$var$alternativeRadioOptionStyles
            ]
        }
    ];
    const fireTextFieldAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'focused',
                actionSubject: 'textField',
                actionSubjectId: 'configPanelButtonField',
                source: `${source}ButtonLabel`
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const fireButtonLinkAnalytics = (0, $42omo.useCallback)((isAddingLink)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: isAddingLink ? 'added' : 'removed',
                actionSubject: 'buttonLink',
                actionSubjectId: 'configPanelButtonLink',
                source: `${source}ButtonLink`
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const selectLink = (0, $42omo.useCallback)((selectedLink)=>{
        handleSelectLink(selectedLink);
        fireButtonLinkAnalytics(true);
    }, [
        fireButtonLinkAnalytics,
        handleSelectLink
    ]);
    const handleDeleteButton = ()=>{
        fireButtonLinkAnalytics(false);
        handleClearButton();
    };
    const handleChange = (event)=>{
        const selectedOption = buttonStyleOptions.find((option)=>option.value === event.currentTarget.value);
        if (selectedOption) updateButtonStyle(selectedOption.value);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        padding: "space.150",
        xcss: $4d261656ae8fd0a9$var$popupWrapper,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
            space: "space.200",
            grow: "fill",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            paddingBlock: "space.050",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                size: "xsmall",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...(0, $252cf81a0f143938$export$defe85febe8b728c).buttonHeading
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            isDisabled: !(text || link),
                            spacing: "compact",
                            appearance: "subtle",
                            onClick: handleDeleteButton,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                            label: intl.formatMessage((0, $252cf81a0f143938$export$defe85febe8b728c).deleteIconLabel),
                            testId: "delete-button"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                    testId: "link-picker-wrapper",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8jjEv.LinkPicker), {
                        cloudId: cloudId,
                        link: link,
                        id: "button-link",
                        handleSelectLink: selectLink,
                        handleClearLink: handleClearLink
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                        maxLength: 40,
                        value: text,
                        onChange: (event)=>{
                            updateButtonText(event.currentTarget.value);
                        },
                        onFocus: fireTextFieldAnalytics,
                        placeholder: intl.formatMessage((0, $252cf81a0f143938$export$defe85febe8b728c).textPlaceholder),
                        testId: "button-name"
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: buttonStyleOptions.map((option, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kZ5GD.default), {
                            value: option.value,
                            label: /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                                alignItems: "center",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                                    xcss: option.styles,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...(0, $252cf81a0f143938$export$defe85febe8b728c).buttonHeading
                                    })
                                })
                            }),
                            name: option.label,
                            isChecked: option.value === style,
                            onChange: handleChange,
                            // Static styling is necessary here to ensure the radio button is centered
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            style: {
                                margin: 'auto'
                            },
                            testId: `button-style-${option.value}`
                        }, index))
                })
            ]
        })
    });
};
module.exports["ButtonConfig"] = $4d261656ae8fd0a9$export$322c06619d3c1a57;

});

parcelRegister("be2Qa", function(module, exports) {
const $6c81ed750728c4c0$var$itemDataKey = Symbol('item');
function $6c81ed750728c4c0$export$dc0c4ec5c1198760({ item: item, index: index }) {
    return {
        [$6c81ed750728c4c0$var$itemDataKey]: true,
        item: item,
        index: index
    };
}
function $6c81ed750728c4c0$export$2a210a87dce1e5bc(data) {
    return data[$6c81ed750728c4c0$var$itemDataKey] === true;
}
module.exports["getItemData"] = $6c81ed750728c4c0$export$dc0c4ec5c1198760;
module.exports["isItemData"] = $6c81ed750728c4c0$export$2a210a87dce1e5bc;

});

parcelRegister("h92Kw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $dpPtd = parcelRequire("dpPtd");


var $a3fRD = parcelRequire("a3fRD");


var $fOKpq = parcelRequire("fOKpq");


var $cQI39 = parcelRequire("cQI39");


var $8Rlmd = parcelRequire("8Rlmd");

const $6b23c8c5038277b4$export$f8da0ec9f5f5f971 = ({ contentId: contentId, handleUploadedImageSelection: handleUploadedImageSelection, analyticsSource: analyticsSource })=>{
    const { createEditorMediaProvider: createEditorMediaProvider, mediaUploadExperienceTracker: mediaUploadExperienceTracker, transformUploadedImageId: transformUploadedImageId } = (0, $fOKpq.useProductDependencies)();
    const [uploadedImageId, setUploadedImageId] = (0, $42omo.useState)(null);
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const intl = (0, $aXWIB.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isUploadingImage, setIsUploadingImage] = (0, $42omo.useState)(false);
    const [isMediaBrowserOpen, setIsMediaBrowserOpen] = (0, $42omo.useState)(false);
    const [mediaConfig, setMediaConfig] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        if (!!uploadedImageId) handleUploadedImageSelection({
            uploadedImageId: uploadedImageId,
            altDescription: ''
        });
    // We only want this logic to run when uploadedImageId changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        uploadedImageId
    ]);
    const openMediaBrowser = ()=>{
        setIsMediaBrowserOpen(true);
    };
    const closeMediaBrowser = ()=>{
        setIsMediaBrowserOpen(false);
    };
    const handleUploadStart = ()=>{
        setIsUploadingImage(true);
        mediaUploadExperienceTracker?.start({
            analyticsSource: analyticsSource
        });
    };
    const showErrorFlag = (0, $42omo.useCallback)(()=>{
        showFlag({
            title: formatMessage((0, $cQI39.messages).errorFlagTitle),
            description: formatMessage((0, $cQI39.messages).errorFlagDescription),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: "",
                size: "medium",
                color: "var(--ds-icon-danger, #C9372C)"
            })
        });
        setIsUploadingImage(false);
    }, [
        formatMessage,
        showFlag
    ]);
    const handleOnError = (payload)=>{
        setIsUploadingImage(false);
        showErrorFlag();
        mediaUploadExperienceTracker?.stopOnError({
            error: payload?.error?.rawError ?? new Error('Error with cards image upload')
        });
    };
    const handleUploadEnd = (event)=>{
        setIsUploadingImage(false);
        const fileType = event?.file?.type;
        const id = event?.file?.id;
        if (!fileType.includes('image')) {
            showErrorFlag();
            mediaUploadExperienceTracker?.stopOnError({
                error: new Error('File type is not image')
            });
        } else if (id) {
            const imageId = transformUploadedImageId ? transformUploadedImageId({
                contentId: contentId,
                fileId: id
            }) : id;
            setUploadedImageId(imageId);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'selected',
                    actionSubject: 'image',
                    source: analyticsSource,
                    attributes: {
                        imageSource: 'customerUpload'
                    }
                }
            }).fire();
            mediaUploadExperienceTracker?.succeed();
        } else {
            showErrorFlag();
            mediaUploadExperienceTracker?.stopOnError({
                error: new Error('File does not have a type or id')
            });
        }
    };
    (0, $42omo.useEffect)(()=>{
        const showAttachmentLimitReachedFlag = (rejectionData)=>{
            if (rejectionData) {
                showFlag((0, $8Rlmd.getAttachmentSizeLimitErrorFlag)(rejectionData, intl));
                setIsUploadingImage(false);
                mediaUploadExperienceTracker?.succeed();
            }
            return !!rejectionData;
        };
        const createMediaConfig = async ()=>{
            try {
                const { uploadParams: uploadParams, uploadMediaClientConfig: uploadMediaClientConfig } = await createEditorMediaProvider?.({
                    contentId: contentId,
                    contentType: 'page',
                    isExternalShare: false,
                    onUploadRejection: showAttachmentLimitReachedFlag
                }) || {};
                if (uploadMediaClientConfig === undefined) return null;
                setMediaConfig({
                    collection: uploadParams?.collection,
                    authProvider: uploadMediaClientConfig.authProvider,
                    onUploadRejection: uploadParams?.onUploadRejection
                });
            } catch (error) {
                mediaUploadExperienceTracker?.stopOnError({
                    error: new Error(`Error with image media provider: ${error}`)
                });
            }
        };
        createMediaConfig();
    }, [
        contentId,
        showErrorFlag,
        showFlag,
        intl,
        mediaUploadExperienceTracker,
        createEditorMediaProvider
    ]);
    return {
        mediaConfig: mediaConfig,
        handleUploadEnd: handleUploadEnd,
        handleUploadStart: handleUploadStart,
        handleOnError: handleOnError,
        isMediaBrowserOpen: isMediaBrowserOpen,
        openMediaBrowser: openMediaBrowser,
        closeMediaBrowser: closeMediaBrowser,
        isUploadingImage: isUploadingImage
    };
};
module.exports["useUploadMediaConfig"] = $6b23c8c5038277b4$export$f8da0ec9f5f5f971;

});

parcelRegister("cQI39", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b215c39e0a4e002f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    errorFlagTitle: {
        id: "company-hub.company-hub-common.link.cards.image.upload.error.flag.title",
        defaultMessage: "We can\u2019t upload your image"
    },
    errorFlagDescription: {
        id: "company-hub.company-hub-common.link.cards.image.upload.error.flag.description",
        defaultMessage: "Refresh the page and try again."
    }
});
module.exports["messages"] = $b215c39e0a4e002f$export$defe85febe8b728c;

});

parcelRegister("8Rlmd", function(module, exports) {

var $7ikOB = parcelRequire("7ikOB");

// Constants
const $91ffb08f53002109$var$SIZE_LIMIT_LEARN_MORE_LINK = 'https://support.atlassian.com/confluence-cloud/docs/upload-a-file/';
const $91ffb08f53002109$var$BYTES_PER_UNIT = 1024;
const $91ffb08f53002109$var$DECIMAL_PLACES = 2;
const $91ffb08f53002109$var$SIZE_UNITS = [
    'bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB'
];
/**
 * Calculates the appropriate unit index for a given byte size
 */ const $91ffb08f53002109$var$calculateUnitIndex = (bytes, maxMagnitude)=>{
    const calculatedIndex = Math.floor(Math.log(bytes) / Math.log($91ffb08f53002109$var$BYTES_PER_UNIT));
    // Only apply maxMagnitude limit if it's truthy and less than the calculated index
    if (maxMagnitude && maxMagnitude < $91ffb08f53002109$var$SIZE_UNITS.length - 1) return Math.min(calculatedIndex, maxMagnitude);
    return calculatedIndex;
};
/**
 * Formats bytes into a human-readable string with appropriate units
 */ const $91ffb08f53002109$var$formatBytesToString = (bytes, unitIndex)=>{
    const convertedSize = bytes / $91ffb08f53002109$var$BYTES_PER_UNIT ** unitIndex;
    const formattedSize = parseFloat(convertedSize.toFixed($91ffb08f53002109$var$DECIMAL_PLACES));
    return `${formattedSize} ${$91ffb08f53002109$var$SIZE_UNITS[unitIndex]}`;
};
const $91ffb08f53002109$export$f2d538a5633fea72 = (bytes, maxMagnitude)=>{
    if (bytes <= 0) return '0 bytes';
    // Validate maxMagnitude parameter (0 means no limit, so it's valid)
    if (maxMagnitude !== undefined && (maxMagnitude < 0 || maxMagnitude >= $91ffb08f53002109$var$SIZE_UNITS.length)) throw new Error(`maxMagnitude must be between 0 and ${$91ffb08f53002109$var$SIZE_UNITS.length - 1}`);
    const unitIndex = $91ffb08f53002109$var$calculateUnitIndex(bytes, maxMagnitude);
    return $91ffb08f53002109$var$formatBytesToString(bytes, unitIndex);
};
/**
 * Creates a flag configuration for file size limit exceeded error
 */ const $91ffb08f53002109$var$createFileSizeLimitExceededFlag = (fileName, limit, intl)=>({
        title: intl.formatMessage((0, $7ikOB.messages).errorTitle, {
            fileName: fileName
        }),
        description: intl.formatMessage((0, $7ikOB.messages).errorDescription, {
            size: $91ffb08f53002109$export$f2d538a5633fea72(limit)
        }),
        actions: [
            {
                content: intl.formatMessage((0, $7ikOB.messages).learnMore),
                onClick: ()=>{
                    window.open($91ffb08f53002109$var$SIZE_LIMIT_LEARN_MORE_LINK, '_blank');
                }
            }
        ]
    });
/**
 * Creates a flag configuration for empty file error
 */ const $91ffb08f53002109$var$createEmptyFileErrorFlag = (data, intl)=>({
        title: intl.formatMessage((0, $7ikOB.messages).zeroByteErrorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage((0, $7ikOB.messages).zeroByteErrorDescription)
    });
const $91ffb08f53002109$export$1c61cf0ed486df46 = (data, intl)=>{
    switch(data.reason){
        case 'fileSizeLimitExceeded':
            return $91ffb08f53002109$var$createFileSizeLimitExceededFlag(data.fileName, data.limit, intl);
        default:
            return $91ffb08f53002109$var$createEmptyFileErrorFlag(data, intl);
    }
};
module.exports["getAttachmentSizeLimitErrorFlag"] = $91ffb08f53002109$export$1c61cf0ed486df46;

});

parcelRegister("7ikOB", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $0278d68a01bcc940$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    errorTitle: {
        id: "company-hub-common.attachment-size-limit-error.title",
        defaultMessage: "{fileName} is too large to upload"
    },
    errorDescription: {
        id: "company-hub-common.attachment-size-limit-error.description",
        defaultMessage: "Attachments must be {size} or less."
    },
    learnMore: {
        id: "company-hub-common.attachment-size-limit-error.learn-more",
        defaultMessage: "Learn more"
    },
    zeroByteErrorTitle: {
        id: "company-hub-common.attachment-zero-byte-error.title",
        defaultMessage: "{fileName} is empty (zero bytes)"
    },
    zeroByteErrorDescription: {
        id: "company-hub-common.attachment-zero-byte.description",
        defaultMessage: "Attachments must be at least 1 byte of size"
    }
});
module.exports["messages"] = $0278d68a01bcc940$export$defe85febe8b728c;

});


//# sourceMappingURL=cards-extension.6cdc431d.js.map
